import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import CachedIcon from "@mui/icons-material/Cached";
import DoctoresService from "../services/DoctoresService";
import SolicitudesService from "../services/SolicitudesService";
import SolicitudesEstudiosService from "../services/SolicitudesEstudiosService";
import EstudiosService from "../services/EstudiosService";
import CajaService from "../services/CajaService";

import EstudiosIntService from "../services/EstudiosIntService";
import SucursalesService from "../services/SucursalesService";
import TelefonosService from "../services/TelefonosService";
import HorariosAtencionService from "../services/HorariosAtencionService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { generarDataUrlQR } from "../utils/qrUtils";
import { mostrarToast } from "../utils/toastUtils";
import { ejecutarConCargandoPDF, mostrarCargandoPDF } from "../utils/pdfLoadingUtils";
import { generarPDFResultados } from "../utils/pdfResultadosUtils";
import ResultadosService from "../services/ResultadosService";
import ParametrosEstudioService from "../services/ParametrosEstudioService";
import MuestrasService from "../services/MuestrasService";
import PacientesService from "../services/PacientesService";
import ConveniosService from "../services/ConveniosService";
import { useLocation } from "react-router-dom";
import socketService from "../services/socketService";

import headerInformeImg from "../img/header-informeResultados.png";
import logoMembreteImg from "../img/logo-membrete.png";
import pieDePaginaImg from "../img/pieDePaginaResultados.jpg";
import firmaRicardoImg from "../img/firma_ricardo.jpg";
import logoLaboratorio from "../img/logo-laboratorio.jpg";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import HistorialEstudiosService from "../services/HistorialEstudiosService";
import HistorialService from "../services/HistorialService";
import { mostrarModalHistorialEstudio, mostrarModalHistorialImpresionEnvio } from "../utils/HistorialSwal";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/EditSquare";
import PrintIcon from '@mui/icons-material/Print';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DescriptionIcon from "@mui/icons-material/Description";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PaymentsIcon from "@mui/icons-material/Payments";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonIcon from "@mui/icons-material/Person";
import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  IconButton,
  Button,
  Tooltip,
  tooltipClasses,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tab,
  Tabs,
  Chip,
  CircularProgress,
  Collapse,
} from "@mui/material";

const normStr = (s) => String(s || "").trim().toUpperCase();

const isSubEstudioFlag = (est) => {
  if (!est) return false;
  return (
    est.registroExamenSub === true ||
    est.registroExamenSub === 1 ||
    String(est.registroExamenSub).toLowerCase() === "si" ||
    String(est.registroExamenSub).toLowerCase() === "s"
  );
};

const parseEdadString = (edadStr) => {
  if (!edadStr) return [0, "AÑOS"];
  const str = String(edadStr).trim();
  const match = str.match(/(\d+(?:\.\d+)?)\s*(AÑOS?|MESES?|DIAS?|DÍAS?|ANOS?)?/i);
  if (match && match[1]) {
    const unidad = match[2] ? match[2].toUpperCase() : "AÑOS";
    return [parseFloat(match[1]), unidad];
  }
  const val = parseFloat(str);
  return [isNaN(val) ? 0 : val, "AÑOS"];
};

const edadEnDias = (valor, unidad) => {
  const v = parseFloat(valor) || 0;
  const u = String(unidad || "AÑOS").toUpperCase();
  if (u.includes("MES")) return v * 30.4375;
  if (u.includes("AÑO") || u.includes("ANO")) return v * 365.25;
  return v;
};

const coincideGenero = (invGenero, pacGenero) => {
  const ig = String(invGenero || "").trim().toLowerCase();
  const pg = String(pacGenero || "").trim().toUpperCase().startsWith("F") ? "F" : "M";
  if (!ig || ig === "ambos" || ig === "ambas" || ig === "todos" || ig === "todas" || ig === "general") return true;
  if (pg === "F") {
    return ig === "mujer" || ig === "mujeres" || ig === "femenino" || ig === "f";
  } else {
    return ig === "hombre" || ig === "hombres" || ig === "masculino" || ig === "m";
  }
};

const obtenerIntervaloCoincidente = (p, pac) => {
  if (!pac) return null;
  const pacGenero = String(pac.sexo || "").trim().toUpperCase().startsWith("F") ? "F" : "M";
  const [edadVal, edadUni] = parseEdadString(pac.edad);
  const pacDias = edadEnDias(edadVal, edadUni);

  const intervals = extractIntervalos(p);
  if (!Array.isArray(intervals) || intervals.length === 0) return null;

  return intervals.find(inv => {
    const gen = inv.genero ?? inv.sexo;
    if (!coincideGenero(gen, pacGenero)) return false;

    const tipoEdad = inv.tipoEdad ?? inv.tipo_edad ?? inv.unidadEdad ?? inv.unidad_edad ?? "AÑOS";
    const rawMin = inv.edadMin ?? inv.edad_min ?? inv.minimoEdad ?? inv.edadMinima;
    const rawMax = inv.edadMax ?? inv.edad_max ?? inv.maximoEdad ?? inv.edadMaxima;

    const minDias = rawMin !== undefined && rawMin !== null && String(rawMin).trim() !== ""
      ? edadEnDias(rawMin, tipoEdad)
      : -Infinity;
    const maxDias = rawMax !== undefined && rawMax !== null && String(rawMax).trim() !== ""
      ? edadEnDias(rawMax, tipoEdad)
      : Infinity;

    return pacDias >= minDias && pacDias <= maxDias;
  }) || null;
};

const htmlToPlainText = (raw) => {
  if (!raw) return "";
  let str = String(raw);
  str = str
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<p[^>]*>/gi, "")
    .replace(/<\/div>/gi, "\n")
    .replace(/<\/h[1-6]>/gi, "\n")
    .replace(/<li[^>]*>/gi, "• ")
    .replace(/<\/li>/gi, "\n")
    .replace(/<\/?ul[^>]*>/gi, "")
    .replace(/<\/?ol[^>]*>/gi, "")
    .replace(/<\/?(?:strong|b|em|i|u|s|span|sub|sup|a|font|mark|small|del|ins|abbr|cite|code|pre|blockquote|table|tr|td|th|thead|tbody|h[1-6]|div)[^>]*>/gi, "")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/gi, "'")
    .replace(/&deg;/gi, "°")
    .replace(/&plusmn;/gi, "±")
    .replace(/&micro;/gi, "µ")
    .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
  return str
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .join("\n");
};

const extractIntervalos = (p) => {
  if (!p) return [];
  const parseIfArrayOrJSON = (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val === "string" && val.trim().startsWith("[")) {
      try {
        const parsed = JSON.parse(val);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        return [];
      }
    }
    return [];
  };

  const sources = [
    p.intervalosBr,
    p.intervalosBR,
    p.intervalos,
    p.intervalos_br,
    p.valoresParametro,
    p.valoresReferencia,
    p.valorReferencia,
    p.valor_referencia,
    p.intervaloBiologicoRef
  ];

  for (const src of sources) {
    const res = parseIfArrayOrJSON(src);
    if (res.length > 0) return res;
  }

  return [];
};

const formatIntervaloBR = (intervalo, unidadMedida) => {
  if (intervalo === null || intervalo === undefined) return "";
  if (typeof intervalo === "string" || typeof intervalo === "number") {
    return String(intervalo).trim();
  }

  const getVal = (...keys) => {
    for (const k of keys) {
      if (intervalo[k] !== undefined && intervalo[k] !== null && String(intervalo[k]).trim() !== "") {
        return intervalo[k];
      }
    }
    return "";
  };

  const minVal = getVal("intervaloMin", "intervalo_min", "minimo", "min", "valMin", "val_min");
  const maxVal = getVal("intervaloMax", "intervalo_max", "maximo", "max", "valMax", "val_max");
  const unitStr = unidadMedida || getVal("unidadMedida", "unidad_medida", "um");
  const unit = unitStr ? ` ${unitStr}` : "";

  let rangoStr = "";
  if (minVal !== "" && maxVal !== "") {
    rangoStr = `${minVal} a ${maxVal}${unit}`;
  } else if (minVal !== "") {
    rangoStr = `> ${minVal}${unit}`;
  } else if (maxVal !== "") {
    rangoStr = `< ${maxVal}${unit}`;
  }

  if (!rangoStr) {
    const rawVal = getVal("valor", "valorReferencia", "valor_referencia", "texto", "descripcion");
    if (rawVal) return String(rawVal).trim();
  }

  return rangoStr;
};

const getCleanValorReferencia = (p) => {
  if (!p) return "";
  let val = p.valorReferencia || p.valor_referencia || p.valorPredeterminado || "";
  if (typeof val === "string" && val.trim().startsWith("{")) {
    try {
      const parsed = JSON.parse(val);
      if (parsed.valorReferencia) return parsed.valorReferencia;
      if (parsed.valorPredeterminado) return parsed.valorPredeterminado;
    } catch (e) { }
  }
  if (typeof val === "string" && val.trim().startsWith("[")) {
    try {
      const parsed = JSON.parse(val);
      if (Array.isArray(parsed) && parsed.length > 0) {
        const lines = parsed.map((i) => formatIntervaloBR(i, p.unidadMedida)).filter(Boolean);
        if (lines.length > 0) return lines.join("\n");
      }
    } catch (e) { }
  }
  return val;
};

const formatParametroIntervalos = (p, pac = null) => {
  if (!p) return "";
  const listIntervalos = extractIntervalos(p);

  if (Array.isArray(listIntervalos) && listIntervalos.length > 0) {
    if (pac) {
      const coincidente = obtenerIntervaloCoincidente(p, pac);
      if (coincidente) {
        return formatIntervaloBR(coincidente, p.unidadMedida);
      }
    }
    const lines = listIntervalos.map((i) => formatIntervaloBR(i, p.unidadMedida)).filter(Boolean);
    if (lines.length > 0) {
      return lines.join("\n");
    }
  }
  const cleanVal = getCleanValorReferencia(p);
  const rawText = cleanVal || p.valorReferencia || p.valor_referencia || p.intervaloBiologicoRef || p.valorPredeterminado || "";
  return htmlToPlainText(rawText);
};

const esParametroBR = (p) => {
  if (!p) return false;
  const tipoRef = String(p.tipoReferencia || p.tipoReferenciaParametro || p.tipoValor || "").toLowerCase().trim();
  if (tipoRef.includes("criterio") || tipoRef.includes("mixto") || tipoRef.includes("texto")) {
    return false;
  }
  if (tipoRef === "intervalobr" || tipoRef === "intervalosbr" || tipoRef === "intervalo") {
    return true;
  }
  const intervalos = extractIntervalos(p);
  return Array.isArray(intervalos) && intervalos.length > 0;
};

const generarQRCanvas = (texto) => {
  try {
    const canvas = document.createElement("canvas");
    canvas.width = 150;
    canvas.height = 150;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, 150, 150);

    ctx.fillStyle = "#000000";
    const drawFinderPattern = (x, y) => {
      ctx.fillRect(x, y, 35, 35);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(x + 5, y + 5, 25, 25);
      ctx.fillStyle = "#000000";
      ctx.fillRect(x + 10, y + 10, 15, 15);
    };

    drawFinderPattern(10, 10);
    drawFinderPattern(105, 10);
    drawFinderPattern(10, 105);

    let hash = 0;
    const s = String(texto || "LABORATORIO");
    for (let i = 0; i < s.length; i++) hash = (hash << 5) - hash + s.charCodeAt(i);

    const gridSize = 15;
    const cellSize = 7;
    const offsetX = 22;
    const offsetY = 22;

    for (let r = 0; r < gridSize; r++) {
      for (let c = 0; c < gridSize; c++) {
        if ((r < 5 && c < 5) || (r < 5 && c > 9) || (r > 9 && c < 5)) continue;
        const val = Math.abs(Math.sin(hash * (r * 15 + c + 1) * 9999));
        if (val > 0.45) {
          ctx.fillRect(offsetX + c * cellSize, offsetY + r * cellSize, cellSize - 1, cellSize - 1);
        }
      }
    }
    return canvas.toDataURL("image/png");
  } catch (e) {
    return null;
  }
};

const ENTREGAS_STATE_KEY = "entregas_view_state";

const saveEntregasState = (stateObj) => {
  try {
    const existing = JSON.parse(sessionStorage.getItem(ENTREGAS_STATE_KEY) || "{}");
    sessionStorage.setItem(ENTREGAS_STATE_KEY, JSON.stringify({ ...existing, ...stateObj }));
  } catch (e) { }
};

const getEntregasState = () => {
  try {
    const s = sessionStorage.getItem(ENTREGAS_STATE_KEY);
    return s ? JSON.parse(s) : null;
  } catch (e) {
    return null;
  }
};

const Entregas = () => {
  const MySwal = withReactContent(Swal);
  const location = useLocation();
  const savedState = getEntregasState() || {};

  useEffect(() => {
    document.title = "Entregas";

    const handleActualizacionEntregas = (data) => {
      console.log("[Real-time] Estado de entrega o solicitud actualizado");
    };

    socketService.on("solicitud_actualizada", handleActualizacionEntregas);
    socketService.on("resultado_actualizado", handleActualizacionEntregas);

    return () => {
      socketService.off("solicitud_actualizada", handleActualizacionEntregas);
      socketService.off("resultado_actualizado", handleActualizacionEntregas);
    };
  }, []);
  function mostrarMensaje(mensaje, callback) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed && callback) {
        callback();
      }
    });
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  const formatFechaImpresion = (fechaInput) => {
    const dateObj = fechaInput ? new Date(fechaInput) : new Date();
    if (isNaN(dateObj.getTime())) return new Date().toLocaleString();
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const dia = String(dateObj.getDate()).padStart(2, "0");
    const mes = meses[dateObj.getMonth()];
    const anio = dateObj.getFullYear();
    const horas = String(dateObj.getHours()).padStart(2, "0");
    const minutos = String(dateObj.getMinutes()).padStart(2, "0");
    return `${dia} ${mes}, ${anio} ${horas}:${minutos} h`;
  };

  const generarBarcode128Canvas = (texto) => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = 300;
      canvas.height = 70;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const patterns = [
        "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
        "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
        "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
        "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
        "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
        "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
        "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
        "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
        "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
        "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
        "114131", "311141", "411131", "211412", "211214", "211232", "2331112"
      ];

      const valText = String(texto || "SOLICITUD").trim();
      let codeSeq = [104];
      let checksum = 104;

      for (let i = 0; i < valText.length; i++) {
        const code = valText.charCodeAt(i) - 32;
        if (code >= 0 && code <= 94) {
          codeSeq.push(code);
          checksum += code * (i + 1);
        }
      }

      const checkCode = checksum % 103;
      codeSeq.push(checkCode);
      codeSeq.push(106);

      let x = 10;
      ctx.fillStyle = "#000000";

      for (let idx = 0; idx < codeSeq.length; idx++) {
        const pattern = patterns[codeSeq[idx]];
        if (!pattern) continue;
        for (let p = 0; p < pattern.length; p++) {
          const width = parseInt(pattern[p], 10) * 2;
          if (p % 2 === 0) {
            ctx.fillRect(x, 5, width, 55);
          }
          x += width;
        }
      }
      return canvas.toDataURL("image/png");
    } catch (e) {
      console.error("Error generando código de barras:", e);
      return null;
    }
  };

  const generarTicketPago = async (resultado) => {
    const doc = new jsPDF({ unit: "mm", format: [75, 284], orientation: "portrait" });

    const pageWidth = 75;
    const mX = 4;
    const cW = pageWidth - mX * 2;
    const cx = pageWidth / 2;

    // 1. Obtener detalles completos de la solicitud si existen
    let solCompleta = {};
    try {
      const resSol = await SolicitudesService.getSolicitudes();
      const listaSol = resSol?.data?.solicitudes || [];
      solCompleta = listaSol.find(s => String(s.idSolicitud) === String(resultado.idSolicitud) || String(s.orden) === String(resultado.orden)) || {};
    } catch (e) {
      console.warn("Error al buscar solicitud general para ticket:", e);
    }

    // 2. Obtener datos de sucursal
    const sucursalNombreVal = resultado.sucursal || resultado.nombreSucursal || solCompleta.sucursal || "";
    let sucursalActual = {};
    let sucursalTelefonosStr = "";
    let horariosFormateados = [];

    try {
      const resSuc = await SucursalesService.getSucursales();
      const listaSuc = resSuc?.data?.sucursales || [];
      sucursalActual = listaSuc.find(
        (s) => String(s.nombre).toLowerCase() === String(sucursalNombreVal).toLowerCase()
      ) || listaSuc[0] || {};
    } catch (e) { console.error("Error sucursales ticket:", e); }

    if (sucursalActual.idSucursal) {
      try {
        const resTels = await TelefonosService.getTelefonosPorSucursal(sucursalActual.idSucursal);
        const listaTels = Array.isArray(resTels) ? resTels : resTels?.telefonos || [];
        sucursalTelefonosStr = listaTels.map((t) => t.telefono || t).join(", ");
      } catch (e) { console.error("Error teléfonos:", e); }

      try {
        const resHorarios = await HorariosAtencionService.getHorariosAtencionPorSucursal(sucursalActual.idSucursal);
        const listaHorarios = Array.isArray(resHorarios) ? resHorarios : resHorarios?.horarios || [];
        const porConcepto = {};
        listaHorarios.forEach((h) => {
          const conc = h.concepto || "Laboratorio";
          if (!porConcepto[conc]) porConcepto[conc] = [];
          porConcepto[conc].push(`${h.dias || ""}: ${h.horario || ""}`);
        });
        Object.keys(porConcepto).forEach((conc) => {
          horariosFormateados.push({ titulo: `Horario de Atención de ${conc}:`, horarios: porConcepto[conc].join(", ") });
        });
      } catch (e) { console.error("Error horarios:", e); }
    }

    if (horariosFormateados.length === 0) {
      horariosFormateados.push({ titulo: "Horario de Atención de Laboratorio:", horarios: "Lunes a Viernes: 8:00 a 14:00 y 17:00 a 19:00 hrs, Sábado: 8:00 a 14:00 hrs" });
    }

    const sucursalNomText = (sucursalActual.nombre || sucursalNombreVal || "").toUpperCase();
    const nombreLab = (sucursalActual.nombreLaboratorio || "LABORATORIO").toUpperCase();
    const leyendaText = sucursalActual.leyenda || "";
    const calleText = [sucursalActual.calle, sucursalActual.numExterior, sucursalActual.numInterior].filter(Boolean).join(" ");
    const colCpText = `Col. ${sucursalActual.colonia || ""} C.P. ${sucursalActual.cPostal || ""} ${sucursalActual.ciudad || ""}, ${sucursalActual.estado || ""}`;
    const telText = `Tel. ${sucursalTelefonosStr || sucursalActual.telefono || ""}`;

    // 3. Obtener datos del paciente
    let pacienteDetalle = {};
    const idPac = resultado.idPaciente || solCompleta.idPaciente;
    if (idPac) {
      try {
        const resPac = await PacientesService.getPacientePorId(idPac);
        pacienteDetalle = resPac?.paciente?.[0] || resPac?.paciente || resPac || {};
      } catch (e) {
        console.warn("Error paciente ticket:", e);
      }
    }

    const nombrePacienteComp = `${resultado.nombrePaciente || pacienteDetalle.nombre || ""} ${resultado.apPaternoPaciente || pacienteDetalle.apPaterno || ""} ${resultado.apMaternoPaciente || pacienteDetalle.apMaterno || ""}`.trim() || "PACIENTE";
    const sexoVal = pacienteDetalle.sexo || resultado.sexo || solCompleta.sexo || "";
    const edadVal = pacienteDetalle.edad || resultado.edad || solCompleta.edad || "";
    const fechaNacVal = pacienteDetalle.fechaNacimiento || resultado.fechaNacimiento || solCompleta.fechaNacimiento || "";

    const sexoTextoTicket = (() => {
      const s = String(sexoVal || "").trim().toUpperCase();
      if (s === "M" || s === "MASCULINO") return "MASCULINO";
      if (s === "F" || s === "FEMENINO") return "FEMENINO";
      return s;
    })();

    // 4. Obtener datos de doctores
    let doctoresNombresArr = [];
    const idsDocs = solCompleta.idDoctores || (solCompleta.idDoctor ? [solCompleta.idDoctor] : (resultado.idDoctor ? [resultado.idDoctor] : []));
    if (Array.isArray(idsDocs) && idsDocs.length > 0) {
      for (const idDoc of idsDocs) {
        if (idDoc) {
          try {
            const resDoc = await DoctoresService.getDoctorPorId(idDoc);
            const docObj = resDoc?.doctor?.[0] || resDoc?.doctor || resDoc;
            if (docObj) {
              const dName = [docObj.nombre, docObj.apPaterno, docObj.apMaterno].filter(Boolean).join(" ");
              if (dName) {
                const isCom = Boolean(docObj.esComision || docObj.conComision);
                doctoresNombresArr.push(dName + (isCom ? " *" : ""));
              }
            }
          } catch (e) {
            console.warn("Error doctor ticket:", e);
          }
        }
      }
    }
    if (doctoresNombresArr.length === 0) {
      const dNameRes = `${resultado.nombreDoctor || resultado.doctor || ""}`.trim();
      if (dNameRes) doctoresNombresArr.push(dNameRes);
    }

    const docRows = doctoresNombresArr.length > 0
      ? doctoresNombresArr.map((dName, dIdx) => [dIdx === 0 ? "Dr(a):" : "", dName])
      : [["Dr(a):", "DOCTOR"]];

    // 5. Obtener empresa/convenio
    let empresaNombre = resultado.empresa || resultado.nombreConvenio || "";
    const idConv = solCompleta.idConvenio || resultado.idConvenio;
    if (!empresaNombre && idConv) {
      try {
        const resConv = await ConveniosService.getConvenioPorId(idConv);
        const convObj = resConv?.convenio?.[0] || resConv?.convenio || resConv;
        empresaNombre = convObj?.nombre || "";
      } catch (e) {
        console.warn("Error convenio ticket:", e);
      }
    }

    const tieneEmpresaTicket = empresaNombre && String(empresaNombre).trim() !== "" && String(empresaNombre).trim() !== "-";
    const pacNombreTicket = tieneEmpresaTicket
      ? `${nombrePacienteComp} (${String(empresaNombre).trim().toUpperCase()})`
      : nombrePacienteComp;

    // 6. Solicitud y Usuario
    const codigoOrdenStr = resultado.orden || resultado.codigo || solCompleta.codigo || "00000000";
    const fechaHoraStr = formatFechaImpresion(resultado.fechaSolicitud || resultado.fecha || solCompleta.fechaSolicitud || solCompleta.fecha || new Date());
    const barcodeImg = generarBarcode128Canvas(codigoOrdenStr);

    const usuarioString = sessionStorage.getItem("usuario");
    const usuarioObj = usuarioString ? JSON.parse(usuarioString) : {};
    const userNombreCompTicket = [usuarioObj?.nombre, usuarioObj?.apPaterno, usuarioObj?.apMaterno]
      .filter(Boolean)
      .join(" ");
    const usuarioNombre = (userNombreCompTicket || usuarioObj?.nombreCompleto || usuarioObj?.usuario || "").toUpperCase();

    // 7. Obtener estudios y fechas de entrega
    let estudiosLista = [];
    try {
      const resEst = await SolicitudesEstudiosService.getEstudiosPorSolicitud(resultado.idSolicitud);
      const rawEstudios = resEst?.estudios || [];
      estudiosLista = await Promise.all(rawEstudios.map(async (est) => {
        try {
          const detalle = await EstudiosService.getEstudioPorId(est.idEstudio);
          return {
            ...est,
            nombre: detalle?.nombre || est.nombreEstudio || "",
            costo: est.precio || est.costo || detalle?.precio || 0,
            fechaEntrega: est.fechaEntrega || ""
          };
        } catch (e) {
          return { ...est, nombre: est.nombreEstudio || "", costo: est.precio || est.costo || 0, fechaEntrega: est.fechaEntrega || "" };
        }
      }));
    } catch (e) { console.error("Error estudios ticket:", e); }

    // 8. Datos de caja
    let subtotalVal = 0, descuentoVal = 0, ivaVal = 0, totalVal = 0, aCuentaVal = 0, adeudoVal = 0;
    try {
      const cajaRes = await CajaService.getCajaPorSolicitud(resultado.idSolicitud);
      const payload = cajaRes?.data ?? cajaRes;
      const items = Array.isArray(payload?.caja) ? payload.caja : (Array.isArray(payload) ? payload : []);
      const datosCaja = items[0] ?? payload?.caja?.[0] ?? payload?.[0] ?? payload;

      subtotalVal = Number(
        datosCaja?.subtotal ??
        datosCaja?.subtotalCaja ??
        datosCaja?.importe ??
        datosCaja?.total ??
        datosCaja?.totalSolicitud ??
        datosCaja?.monto ??
        0
      );
      if (subtotalVal === 0 && estudiosLista.length > 0) {
        subtotalVal = estudiosLista.reduce((acc, est) => acc + Number(est.costo || 0), 0);
      }

      descuentoVal = Number(
        datosCaja?.descuento ??
        datosCaja?.descuentoTotal ??
        datosCaja?.descuentoSolicitud ??
        0
      );

      ivaVal = Number(
        datosCaja?.iva ??
        datosCaja?.ivaTotal ??
        datosCaja?.montoIva ??
        0
      );

      adeudoVal = Number(
        datosCaja?.adeudo ??
        datosCaja?.saldoPendiente ??
        datosCaja?.restante ??
        datosCaja?.saldo ??
        datosCaja?.pendiente ??
        datosCaja?.deuda ??
        0
      );

      const aCuentaExplicito = Number(
        datosCaja?.aCuenta ??
        datosCaja?.acuenta ??
        datosCaja?.pagado ??
        datosCaja?.montoPagado ??
        datosCaja?.totalPagado ??
        datosCaja?.pagos ??
        datosCaja?.importePagado ??
        datosCaja?.pagadoSolicitud ??
        datosCaja?.abono ??
        datosCaja?.abonos ??
        0
      );

      totalVal = Math.max(0, subtotalVal - descuentoVal + ivaVal);
      aCuentaVal = aCuentaExplicito > 0
        ? aCuentaExplicito
        : (adeudoVal > 0 ? Math.max(0, totalVal - adeudoVal) : Math.max(0, totalVal));
    } catch (e) {
      console.error("Error caja ticket:", e);
      if (subtotalVal === 0 && estudiosLista.length > 0) {
        subtotalVal = estudiosLista.reduce((acc, est) => acc + Number(est.costo || 0), 0);
      }
      totalVal = Math.max(0, subtotalVal - descuentoVal + ivaVal);
      aCuentaVal = totalVal;
    }

    const restanteVal = adeudoVal > 0 ? adeudoVal : Math.max(0, totalVal - aCuentaVal);
    const requiereFactura = Boolean(solCompleta.requiereFactura || resultado.requiereFactura);
    const estaPagado = (aCuentaVal >= totalVal && totalVal > 0) || restanteVal <= 0 || Boolean(resultado.pagado);

    let y = 4;

    // 1. Logo centrado
    try {
      const lw = 30; const lh = 18;
      doc.addImage(logoLaboratorio, "JPEG", cx - lw / 2, y, lw, lh);
      y += lh + 5;
    } catch (e) { y += 23; }

    // 2. Nombre laboratorio
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    doc.setTextColor(0, 0, 0);
    doc.text(nombreLab, cx, y, { align: "center" });
    y += 4;

    // 3. Nombre sucursal
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    doc.text(sucursalNomText, cx, y, { align: "center" });
    y += 4;

    // 4. Leyenda
    if (leyendaText) {
      doc.setFontSize(6.5);
      const leyLines = doc.splitTextToSize(leyendaText, cW);
      doc.text(leyLines, cx, y, { align: "center" });
      y += leyLines.length * 3 + 1;
    }

    // 5. Cuadro "Solicitud de Exámenes"
    y += 1;
    doc.setFillColor(24, 35, 79);
    doc.rect(mX, y, cW, 6.5, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text("Solicitud de Exámenes", cx, y + 4.3, { align: "center" });
    doc.setTextColor(0, 0, 0);
    y += 10;

    // 6. Dirección
    doc.setFontSize(7);
    if (calleText.trim()) {
      doc.setFont("helvetica", "bold");
      doc.text("Dirección: ", mX, y);
      const lbW = doc.getTextWidth("Dirección: ");
      doc.setFont("helvetica", "normal");
      const calleLines = doc.splitTextToSize(calleText, cW - lbW);
      doc.text(calleLines[0], mX + lbW, y);
      if (calleLines.length > 1) {
        y += 3.5;
        doc.text(doc.splitTextToSize(calleLines.slice(1).join(" "), cW), mX, y);
      }
      y += 3.5;
    }
    const colLines = doc.splitTextToSize(colCpText, cW);
    doc.setFont("helvetica", "normal");
    doc.text(colLines, mX, y);
    y += colLines.length * 3.5;
    if (telText.trim() !== "Tel.") {
      doc.text(telText, mX, y);
      y += 3.5;
    }
    y += 2;

    // 7. Recuadro + Tabla info paciente
    const infoRows = [
      ["Paciente:", pacNombreTicket],
      ["Sexo / Edad:", `${sexoTextoTicket} / ${edadVal || ""}`.trim()],
      ["Fecha Nac.:", fechaNacVal ? fechaNacVal : "//"],
      ...docRows,
      ["Fecha solicitud:", fechaHoraStr],
      ["Solicitud:", codigoOrdenStr],
      ["Le atendió:", usuarioNombre],
    ];

    const tableStartY = y;
    autoTable(doc, {
      startY: tableStartY + 1,
      margin: { left: mX + 1.5, right: mX + 1.5 },
      tableWidth: cW - 3,
      body: infoRows,
      styles: { fontSize: 7, cellPadding: 0.9, valign: "middle", textColor: [0, 0, 0] },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 27 },
        1: { cellWidth: cW - 3 - 27 },
      },
      theme: "plain",
    });

    const boxPacH = doc.lastAutoTable.finalY - tableStartY + 1;
    doc.setDrawColor(200, 220, 240);
    doc.setFillColor(245, 248, 252);
    doc.roundedRect(mX, tableStartY, cW, boxPacH, 2, 2, "FD");

    autoTable(doc, {
      startY: tableStartY + 1,
      margin: { left: mX + 1.5, right: mX + 1.5 },
      tableWidth: cW - 3,
      body: infoRows,
      styles: { fontSize: 7, cellPadding: 0.9, valign: "middle", textColor: [0, 0, 0] },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 27 },
        1: { cellWidth: cW - 3 - 27 },
      },
      theme: "plain",
    });
    y = doc.lastAutoTable.finalY + 2;

    // 8. Código de barras
    if (barcodeImg) {
      doc.addImage(barcodeImg, "PNG", mX, y + 3, cW, 14);
      y += 19;
    }

    // 9. Tabla estudios: Estudio | Importe (con Entrega debajo del importe)
    const rowsTicket = [];
    estudiosLista.forEach((est) => {
      if (!est.nombre && !est.codigo) return;
      const nomEst = (est.nombre || "").toUpperCase();
      const impVal = Number(est.costo || 0);
      const entregaStr = est.fechaEntrega ? `Entrega: ${est.fechaEntrega}` : "";
      rowsTicket.push([
        nomEst,
        {
          content: `$ ${impVal.toFixed(2)}${entregaStr ? `\n${entregaStr}` : ""}`,
          styles: { halign: "right", fontStyle: entregaStr ? "normal" : "normal" },
          _entrega: entregaStr,
          _importe: `$ ${impVal.toFixed(2)}`,
        },
      ]);
    });

    autoTable(doc, {
      startY: y,
      margin: { left: mX, right: mX },
      tableWidth: cW,
      head: [
        [
          { content: "ESTUDIO", styles: { halign: "left" } },
          { content: "IMPORTE", styles: { halign: "right" } },
        ],
      ],
      body: rowsTicket,
      styles: { fontSize: 7.5, cellPadding: 1, valign: "top", textColor: [0, 0, 0] },
      headStyles: { fillColor: [210, 228, 243], textColor: [24, 35, 79], fontStyle: "bold", fontSize: 7.5 },
      columnStyles: {
        0: { cellWidth: cW * 0.6 },
        1: { cellWidth: cW * 0.4, halign: "right" },
      },
      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 1) {
          const raw = data.row.raw;
          if (raw[1]?._entrega) {
            data.cell._customImporte = true;
            data.cell._importe = raw[1]._importe;
            data.cell._entrega = raw[1]._entrega;
            data.cell.text = [raw[1]._importe, raw[1]._entrega];
          }
        }
      },
      willDrawCell: (data) => {
        if (data.section === "body" && data.column.index === 1 && data.cell._customImporte) {
          const x = data.cell.x + data.cell.width - data.cell.padding("right");
          const y0 = data.cell.y + data.cell.padding("top") + 3;
          doc.setFontSize(7.5);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.text(data.cell._importe, x, y0, { align: "right" });
          doc.setFont("helvetica", "bold");
          doc.setFontSize(6.5);
          doc.text(data.cell._entrega, x, y0 + 3.5, { align: "right" });
          return false;
        }
      },
    });
    y = doc.lastAutoTable.finalY + 3;

    // 10. Totales
    doc.setFontSize(8);
    const totX = mX + cW;

    if (subtotalVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("Subtotal", mX + cW * 0.4, y);
      doc.text(`$ ${subtotalVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }
    if (descuentoVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("Descuento", mX + cW * 0.4, y);
      doc.text(`$ ${descuentoVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }
    if (requiereFactura && ivaVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("IVA (16%)", mX + cW * 0.4, y);
      doc.text(`$ ${ivaVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }
    doc.setFont("helvetica", "bold");
    doc.text("Total", mX + cW * 0.4, y);
    doc.text(`$ ${totalVal.toFixed(2)}`, totX, y, { align: "right" });
    y += 4;
    if (aCuentaVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("A cuenta", mX + cW * 0.4, y);
      doc.text(`$ ${aCuentaVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }
    if (!estaPagado && restanteVal > 0) {
      doc.setFont("helvetica", "bold");
      doc.text("Restante", mX + cW * 0.4, y);
      doc.text(`$ ${restanteVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }

    // 11. PAGADO
    if (estaPagado) {
      y += 6;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("P A G A D O", cx, y, { align: "center" });
      y += 8;
    }

    // 12. Horarios
    y += 2;
    doc.setFontSize(7);
    horariosFormateados.forEach(({ titulo, horarios }) => {
      doc.setFont("helvetica", "bold");
      const titLines = doc.splitTextToSize(titulo, cW);
      doc.text(titLines, mX, y);
      y += titLines.length * 3.5;
      doc.setFont("helvetica", "normal");
      const horLines = doc.splitTextToSize(horarios, cW);
      doc.text(horLines, mX, y);
      y += horLines.length * 3.5 + 1;
    });

    const nombreArchivo = `ticketPago-${codigoOrdenStr}.pdf`;
    doc.setProperties({ title: nombreArchivo });
    return { blob: doc.output("blob", { filename: nombreArchivo }), nombre: nombreArchivo };
  };

  function reloadPage() {
    window.location.reload();
  }

  const [viewOnly, setViewOnly] = useState(false);
  const [activeTabEntregas, setActiveTabEntregas] = useState(savedState.activeTabEntregas || 0);
  const [paginaActual, setPaginaActual] = useState(savedState.paginaActual || 1);

  const [solicitudesAEntregar, setSolicitudesAEntregar] = useState([]);
  const [solicitudesEntregadas, setSolicitudesEntregadas] = useState([]);

  const [loadingTabla, setLoadingTabla] = useState(true);

  const fetchSolicitudes = async () => {
    setLoadingTabla(true);
    try {
      const response = await SolicitudesService.getSolicitudesResultados();

      let solicitudesGeneral = [];
      try {
        const generalRes = await SolicitudesService.getSolicitudes();
        solicitudesGeneral = generalRes?.data?.solicitudes || [];
      } catch (errorGeneral) {
        console.error("Error fetching general solicitudes for mapping payment status:", errorGeneral);
      }

      const estatusMap = {};
      solicitudesGeneral.forEach(s => {
        if (s.idSolicitud) {
          estatusMap[s.idSolicitud] = s.estatus;
        }
      });

      const mapearEstatus = (lista) => {
        return lista.map(sol => {
          const solG = solicitudesGeneral.find(sg => String(sg.idSolicitud || sg.orden) === String(sol.idSolicitud || sol.orden)) || {};
          return {
            ...solG,
            ...sol,
            idPaciente: sol.idPaciente || solG.idPaciente || null,
            telefonoCelular: sol.telefonoCelular || solG.telefonoCelular || sol.telefono || solG.telefono || "",
            email: sol.email || solG.email || sol.correo || solG.correo || "",
            estatus: solG.estatus || sol.estatus || "S",
            nombreRecibe: sol.nombreRecibe || solG.nombreRecibe || "",
            identificacionRecibe: sol.identificacionRecibe || solG.identificacionRecibe || ""
          };
        });
      };

      const aEntregar = mapearEstatus(response.data.a_entregar || []);
      const hoy = mapearEstatus(response.data.hoy || []);
      const posteriores = mapearEstatus(response.data.posteriores || []);
      const entregadas = mapearEstatus(response.data.entregadas || []);

      // Unir por entregar sin duplicados
      const porEntregarMap = {};
      [...hoy, ...posteriores, ...aEntregar].forEach(s => {
        porEntregarMap[s.orden] = s;
      });

      const porEntregarList = Object.values(porEntregarMap);

      // Verificar estado de pago real consultando caja para cada solicitud
      const verificarPago = async (sol) => {
        try {
          const cajaRes = await CajaService.getCajaPorSolicitud(sol.idSolicitud);
          const payload = cajaRes?.data ?? cajaRes;
          const items = Array.isArray(payload?.caja) ? payload.caja : (Array.isArray(payload) ? payload : []);
          const datosCaja = items[0] ?? payload?.caja?.[0] ?? payload?.[0] ?? payload;
          const adeudo = Number(
            datosCaja?.adeudo ??
            datosCaja?.saldoPendiente ??
            datosCaja?.restante ??
            datosCaja?.saldo ??
            datosCaja?.pendiente ??
            datosCaja?.deuda ??
            1
          );
          return { ...sol, pagado: adeudo <= 0 };
        } catch (e) {
          return { ...sol, pagado: false };
        }
      };

      const porEntregarConPago = await Promise.all(porEntregarList.map(verificarPago));
      const entregadasConPago = await Promise.all(entregadas.map(verificarPago));

      setSolicitudesAEntregar(porEntregarConPago);
      setSolicitudesEntregadas(entregadasConPago);
    } catch (err) {
      console.error("Error al cargar solicitudes:", err);
    } finally {
      setLoadingTabla(false);
    }
  };

  const [filtroTexto, setFiltroTexto] = useState(savedState.filtroTexto || "");
  const [filtroFecha, setFiltroFecha] = useState(savedState.filtroFecha || "3m");

  useEffect(() => {
    saveEntregasState({ filtroTexto, filtroFecha, paginaActual, activeTabEntregas });
  }, [filtroTexto, filtroFecha, paginaActual, activeTabEntregas]);

  const [mostrarTabla, setMostrarTabla] = useState(false);

  const [expandedSolicitudes, setExpandedSolicitudes] = useState({});
  const [loadingEstudios, setLoadingEstudios] = useState({});
  const [estudiosPorSolicitud, setEstudiosPorSolicitud] = useState({});
  const [selectedEstudios, setSelectedEstudios] = useState({});

  const fetchEstudiosForSolicitud = async (orden, idSolicitudDirecta) => {
    const key = String(idSolicitudDirecta || orden);
    setLoadingEstudios((prev) => ({ ...prev, [key]: true, [orden]: true }));
    try {
      const idSolicitud = idSolicitudDirecta || (typeof orden === "number" || /^\d+$/.test(orden) ? orden : null);
      if (idSolicitud) {
        const res = await SolicitudesEstudiosService.getEstudiosPorSolicitud(idSolicitud);
        const estudiosList = res?.estudios || [];

        const subEstatusRes = await SolicitudesEstudiosService.getEstatusSubPorSolicitud(idSolicitud);
        const subEstatusList = subEstatusRes?.estatusSub || [];

        const estudiosConDetalles = await Promise.all(
          estudiosList.map(async (est) => {
            try {
              const estudioDetalle = await EstudiosService.getEstudioPorId(est.idEstudio);

              let subExamenes = [];
              let registroExamenSub = false;

              if (estudioDetalle) {
                registroExamenSub = estudioDetalle.registroExamenSub === true || estudioDetalle.registroExamenSub === 1 || String(estudioDetalle.registroExamenSub).toLowerCase() === "si";

                if (registroExamenSub) {
                  const resInt = await EstudiosIntService.getEstudiosPorEstudio(est.idEstudio) || [];
                  for (const sub of resInt) {
                    try {
                      const subDetalle = await EstudiosService.getEstudioPorId(sub.idEstudioSec);
                      if (subDetalle) {
                        const matchSub = subEstatusList.find(se => se.idEstudioSec === sub.idEstudioSec && se.idEstudioPadre === est.idEstudio);
                        const subEstatus = matchSub ? matchSub.estatus : "E";
                        subExamenes.push({
                          idEstudio: sub.idEstudioSec,
                          idEstudioPadre: est.idEstudio,
                          codigo: subDetalle.codigo || "",
                          nombre: subDetalle.nombre || "",
                          esSubrogado: subDetalle.esSubrogado || false,
                          estatus: subEstatus
                        });
                      }
                    } catch (errSub) {
                      console.error("Error fetching sub-study details:", errSub);
                    }
                  }
                }
              }

              return {
                ...est,
                codigo: estudioDetalle?.codigo || "",
                nombre: estudioDetalle?.nombre || est.nombreEstudio || "",
                esSubrogado: estudioDetalle?.esSubrogado || false,
                registroExamenSub,
                subExamenes
              };
            } catch (e) {
              console.error("Error fetching study details:", e);
              return {
                ...est,
                codigo: "",
                nombre: est.nombreEstudio || "",
                esSubrogado: false,
                registroExamenSub: false,
                subExamenes: []
              };
            }
          })
        );

        setEstudiosPorSolicitud((prev) => ({
          ...prev,
          [key]: estudiosConDetalles,
          [orden]: estudiosConDetalles,
        }));
      } else {
        console.warn("No se encontró idSolicitud para la orden:", orden);
        setEstudiosPorSolicitud((prev) => ({
          ...prev,
          [key]: [],
          [orden]: [],
        }));
      }
    } catch (error) {
      console.error("Error cargando estudios:", error);
    } finally {
      setLoadingEstudios((prev) => ({ ...prev, [key]: false, [orden]: false }));
    }
  };

  useEffect(() => {
    try {
      const saved = getEntregasState();
      const opened = saved?.openedSolicitud || location.state?.solicitud || location.state?.solicitudRetorno;

      if (opened) {
        const orden = opened.orden || opened.codigo;
        const idSol = opened.idSolicitud || opened.id;
        const key = String(idSol || orden);
        if (key) {
          setExpandedSolicitudes((prev) => ({
            ...prev,
            [key]: true,
            [orden]: true,
          }));

          const intervalId = setInterval(() => {
            fetchEstudiosForSolicitud(orden, idSol);
            clearInterval(intervalId);
          }, 250);
        }
      }
    } catch (e) {
      console.warn("Error al restaurar solicitud previa:", e);
    }
  }, []);

  const handleToggleExpand = async (orden, idSolicitudDirecta) => {
    const key = String(idSolicitudDirecta || orden);
    const isExpanded = !!expandedSolicitudes[key] || !!expandedSolicitudes[orden];
    setExpandedSolicitudes((prev) => ({
      ...prev,
      [key]: !isExpanded,
      [orden]: !isExpanded,
    }));

    if (!isExpanded) {
      saveEntregasState({ openedSolicitud: { orden, idSolicitud: idSolicitudDirecta } });
      if (!estudiosPorSolicitud[key] && !estudiosPorSolicitud[orden]) {
        await fetchEstudiosForSolicitud(orden, idSolicitudDirecta);
      }
    } else {
      saveEntregasState({ openedSolicitud: null });
    }
  };

  const handleToggleSelectEstudio = (idSolicitud, idEstudio, subExamenes = null, parentId = null) => {
    const key = `${idSolicitud}-${idEstudio}`;
    setSelectedEstudios((prev) => {
      const willBeSelected = !prev[key];
      const nextState = { ...prev, [key]: willBeSelected };

      if (willBeSelected) {
        // Si se selecciona el estudio principal/padre, des-seleccionar todos sus subestudios
        if (Array.isArray(subExamenes) && subExamenes.length > 0) {
          subExamenes.forEach((sub) => {
            const subKey = `${idSolicitud}-${sub.idEstudio}`;
            nextState[subKey] = false;
          });
        }
        // Si se selecciona un subestudio hijo, des-seleccionar el estudio padre
        if (parentId) {
          const parentKey = `${idSolicitud}-${parentId}`;
          nextState[parentKey] = false;
        }
      }

      return nextState;
    });
  };

  const handleHistorialModificaciones = (solicitud, estudio) => {
    mostrarModalHistorialEstudio(solicitud, estudio);
  };

  const handleHistorialImpresionEnvio = (solicitud) => {
    mostrarModalHistorialImpresionEnvio(solicitud);
  };

  const generarPDFResultadosEntregas = async (solicitudObj, studiesInput = [], isDownload = false, returnBlobOnly = false) => {
    try {
      const res = await generarPDFResultados(solicitudObj, studiesInput, isDownload, returnBlobOnly);
      if (typeof fetchSolicitudes === "function") {
        try {
          fetchSolicitudes();
        } catch (e) { }
      }
      return res;
    } catch (errPDF) {
      console.error("Error al generar PDF de resultados en Entregas:", errPDF);
      Swal.fire("Error", "No se pudo generar el informe de resultados PDF.", "error");
      return null;
    }
  };

  const handleEnviarInformeWhatsApp = async (resultado, studiesInput = []) => {
    const idSol = resultado?.idSolicitud || resultado?.orden || resultado?.codigo;
    if (!idSol) {
      Swal.fire("Error", "No se pudo identificar la solicitud para enviar su informe.", "error");
      return;
    }

    let telefonoInicial = resultado?.telefonoCelular || resultado?.telefono || resultado?.pacienteTelefono || "";
    if (!telefonoInicial) {
      try {
        let idPac = resultado?.idPaciente;
        if (!idPac && idSol) {
          const resSolicitudes = await SolicitudesService.getSolicitudes();
          const listaSolicitudes = resSolicitudes?.data?.solicitudes || resSolicitudes?.data || [];
          const sFound = listaSolicitudes.find(s => String(s.idSolicitud || s.orden || s.codigo) === String(idSol));
          if (sFound) {
            telefonoInicial = sFound.telefonoCelular || sFound.telefono || sFound.pacienteTelefono || "";
            idPac = sFound.idPaciente;
          }
        }
        if (!telefonoInicial && idPac) {
          const resPac = await PacientesService.getPacientePorId(idPac);
          const pac = resPac?.paciente?.[0] || resPac?.paciente || resPac?.data?.paciente?.[0] || resPac?.data?.paciente || resPac;
          telefonoInicial = pac?.telefonoCelular || pac?.telefono || pac?.celular || "";
        }
      } catch (eTel) {
        console.warn("No se pudo obtener el teléfono del paciente:", eTel);
      }
    }

    const { value: telefono } = await Swal.fire({
      title: "Enviar Informe de Resultados por WhatsApp",
      text: "Ingresa el número telefónico al cual deseas enviar el informe de resultados:",
      input: "text",
      inputValue: telefonoInicial,
      inputPlaceholder: "Ej. 5512345678",
      showCancelButton: true,
      confirmButtonText: "Enviar a WhatsApp",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#25D366",
      cancelButtonColor: "#d33",
      inputValidator: (value) => {
        if (!value || value.trim() === "") {
          return "Debes ingresar un número telefónico";
        }
        const numLimpio = value.replace(/\D/g, "");
        if (numLimpio.length > 10) {
          return "El número de teléfono no puede tener más de 10 dígitos";
        }
        if (numLimpio.length < 10) {
          return "Ingresa un número válido de 10 dígitos";
        }
      },
    });

    if (!telefono) return;

    try {
      // 1. Generar el PDF del Informe de Resultados (con validación de pago adentro)
      let resPdf = null;
      await ejecutarConCargandoPDF(
        async () => {
          resPdf = await generarPDFResultadosEntregas(resultado, studiesInput, false, true);
        },
        "Generando informe de resultados...",
        "Procesando documento"
      );

      if (!resPdf || !resPdf.blob) return;

      const blob = resPdf.blob;

      // 2. Subir el PDF generado al backend para obtener el token/link de descarga seguro
      const formData = new FormData();
      formData.append("ticketPdf", blob, `informe_${idSol}.pdf`);
      formData.append("idSolicitud", idSol);
      formData.append("tipoDocumento", "informe");

      let linkInforme = "";
      try {
        const resp = await SolicitudesService.uploadTicketWhatsApp(formData, idSol);
        linkInforme = resp?.data?.linkDownload || `http://localhost:4000/solicitudes/ticket/public/${resp?.data?.token || idSol}`;
      } catch (errUpload) {
        console.warn("Backend ticket upload error, usando ruta por defecto:", errUpload);
        linkInforme = `http://localhost:4000/solicitudes/ticket/public/${idSol}`;
      }

      // 3. Formatear teléfono a 10+ dígitos (agregando lada México 521 si es de 10 dígitos)
      let numLimpio = telefono.replace(/\D/g, "");
      if (numLimpio.length === 10) {
        numLimpio = `521${numLimpio}`;
      }

      // 4. Construir el mensaje exacto
      const mensaje = `Laboratorios García ha enviado su informe de resultados para visualizarlo de clic en el siguiente link : ${linkInforme}`;

      // 5. Redirigir al chat de WhatsApp
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${numLimpio}&text=${encodeURIComponent(mensaje)}`;
      window.open(whatsappUrl, "_blank");

      // 6. Registrar en AMBOS historiales (de la solicitud Y de impresión/envío)
      const usuarioString = sessionStorage.getItem("usuario");
      const usuarioObj = usuarioString ? JSON.parse(usuarioString) : {};
      const empNombre = [usuarioObj?.nombre, usuarioObj?.apPaterno, usuarioObj?.apMaterno]
        .filter(Boolean).join(" ") || usuarioObj?.nombre || "EMPLEADO";

      const opTexto = `Se envió informe de resultados por WhatsApp al número ${numLimpio}`;

      // A) Historial de la Solicitud (HistorialService)
      try {
        await HistorialService.registrarEvento({
          idSolicitud: idSol,
          nombreEmpleado: empNombre,
          operacion: opTexto,
        });
      } catch (eH1) {
        console.warn("Error guardando en historial de solicitud:", eH1);
      }

      // B) Historial de Impresión / Envío (HistorialEstudiosService)
      try {
        await HistorialEstudiosService.registrarMovimiento({
          idSolicitud: idSol,
          idEstudio: 0,
          nombreEstudio: opTexto,
          nombreEmpleado: empNombre,
          tipoAccion: "D",
        });
      } catch (eH2) {
        console.warn("Error guardando en historial de impresión/envío:", eH2);
      }

    } catch (error) {
      console.error("Error al generar o enviar informe por WhatsApp:", error);
      Swal.fire("Error", "No se pudo generar o enviar el enlace del informe de resultados por WhatsApp.", "error");
    }
  };

  const handleEnviarCorreoInforme = async (resultado, studiesInput = []) => {
    const idSol = resultado?.idSolicitud || resultado?.orden || resultado?.codigo;
    const codigoSol = resultado?.codigo || resultado?.orden || idSol;
    if (!idSol) {
      Swal.fire("Error", "No se pudo identificar la solicitud para enviar su correo.", "error");
      return;
    }

    let emailInicial = resultado?.email || resultado?.correo || resultado?.emailPaciente || "";
    if (!emailInicial) {
      try {
        let idPac = resultado?.idPaciente;
        if (!idPac && idSol) {
          const resSolicitudes = await SolicitudesService.getSolicitudes();
          const listaSolicitudes = resSolicitudes?.data?.solicitudes || resSolicitudes?.data || [];
          const sFound = listaSolicitudes.find(s => String(s.idSolicitud || s.orden || s.codigo) === String(idSol));
          if (sFound) {
            emailInicial = sFound.email || sFound.correo || sFound.emailPaciente || "";
            idPac = sFound.idPaciente;
          }
        }
        if (!emailInicial && idPac) {
          const resPac = await PacientesService.getPacientePorId(idPac);
          const pac = resPac?.paciente?.[0] || resPac?.paciente || resPac?.data?.paciente?.[0] || resPac?.data?.paciente || resPac;
          emailInicial = pac?.email || pac?.correo || "";
        }
      } catch (eEmail) {
        console.warn("No se pudo obtener el correo del paciente:", eEmail);
      }
    }

    const { value: email } = await Swal.fire({
      title: "Enviar Informe por Correo Electrónico",
      text: "Ingresa el correo electrónico al cual deseas enviar el informe de resultados:",
      input: "email",
      inputValue: emailInicial,
      inputPlaceholder: "ejemplo@correo.com",
      showCancelButton: true,
      confirmButtonText: "Enviar Correo",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ffb300",
      cancelButtonColor: "#d33",
      inputValidator: (value) => {
        if (!value || !value.includes("@")) {
          return "Ingresa un correo electrónico válido";
        }
      },
    });

    if (!email) return;

    try {
      // 1. Generar el PDF del Informe de Resultados (con validación de pago adentro)
      let resPdf = null;
      await ejecutarConCargandoPDF(
        async () => {
          resPdf = await generarPDFResultadosEntregas(resultado, studiesInput, false, true);
        },
        "Generando informe de resultados...",
        "Procesando documento"
      );

      if (!resPdf || !resPdf.blob) return;

      const blob = resPdf.blob;

      // 2. Preparar el envío al backend
      const pacUpper = String(resultado?.paciente || resultado?.nombrePaciente || "PACIENTE").trim().replace(/\s+/g, " ").replace(/[\\/:*?"<>|]/g, "").toUpperCase();
      const codSolSafe = String(codigoSol || idSol || "").trim().replace(/[\\/:*?"<>|]/g, "");
      const nombreAdjuntoCorreo = `${pacUpper}_${codSolSafe}.pdf`;

      const formData = new FormData();
      formData.append("pdf", blob, nombreAdjuntoCorreo);
      formData.append("idSolicitud", idSol);
      formData.append("codigoSolicitud", codigoSol);
      formData.append("email", email.trim());

      // Mostrar cargando
      Swal.fire({
        title: "Enviando correo...",
        text: "Por favor espere un momento",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      let resp;
      try {
        resp = await SolicitudesService.enviarCorreoInforme(formData);
      } catch (errApi) {
        console.warn("Backend enviar-correo error:", errApi);
        resp = { data: { estatus: "ERROR", mensaje: errApi?.response?.data?.mensaje || "Error al conectar con el servidor" } };
      }

      if (resp?.data?.estatus === "OK") {
        mostrarToast(`Correo enviado con éxito a ${email.trim()}`, "success");

        // 3. Registrar en AMBOS historiales (de la solicitud Y de impresión/envío)
        const usuarioString = sessionStorage.getItem("usuario");
        const usuarioObj = usuarioString ? JSON.parse(usuarioString) : {};
        const empNombre = [usuarioObj?.nombre, usuarioObj?.apPaterno, usuarioObj?.apMaterno]
          .filter(Boolean).join(" ") || usuarioObj?.nombre || "EMPLEADO";

        const opTexto = `Se envió informe de resultados por correo electrónico a ${email.trim()}`;

        // A) Historial de la Solicitud (HistorialService)
        try {
          await HistorialService.registrarEvento({
            idSolicitud: idSol,
            nombreEmpleado: empNombre,
            operacion: opTexto,
          });
        } catch (eH1) {
          console.warn("Error guardando en historial de solicitud:", eH1);
        }

        // B) Historial de Impresión / Envío (HistorialEstudiosService)
        try {
          await HistorialEstudiosService.registrarMovimiento({
            idSolicitud: idSol,
            idEstudio: 0,
            nombreEstudio: opTexto,
            nombreEmpleado: empNombre,
            tipoAccion: "D",
          });
        } catch (eH2) {
          console.warn("Error guardando en historial de impresión/envío:", eH2);
        }
      } else {
        Swal.fire("Error al enviar", resp?.data?.mensaje || "No se pudo enviar el correo electrónico.", "error");
      }

    } catch (error) {
      console.error("Error al enviar informe por correo:", error);
      Swal.fire("Error", "Ocurrió un fallo al procesar el envío por correo electrónico.", "error");
    }
  };

  const handleImprimirSolicitud = async (solicitud, studies = []) => {
    await ejecutarConCargandoPDF(
      async () => {
        await generarPDFResultadosEntregas(solicitud, studies, false);
      },
      "Generando informe de resultados completo...",
      "Procesando PDF"
    );
  };

  const handleDescargarPdfSolicitud = async (solicitud, studies = []) => {
    await ejecutarConCargandoPDF(
      async () => {
        await generarPDFResultadosEntregas(solicitud, studies, true);
      },
      "Generando archivo PDF para descarga...",
      "Procesando PDF"
    );
  };

  const handleImprimirEstudioIndividual = async (solicitud, estudio) => {
    await ejecutarConCargandoPDF(
      async () => {
        await generarPDFResultadosEntregas(solicitud, [estudio], false);
      },
      "Generando informe del estudio seleccionado...",
      "Procesando PDF"
    );
  };

  const handleDescargarPdfEstudioIndividual = async (solicitud, estudio) => {
    await ejecutarConCargandoPDF(
      async () => {
        await generarPDFResultadosEntregas(solicitud, [estudio], true);
      },
      "Generando archivo PDF del estudio seleccionado...",
      "Procesando PDF"
    );
  };

  async function handleRecibeResultados(resultado) {
    if (!resultado || !resultado.idSolicitud) return;

    const nombreRecibePrevio = resultado.nombreRecibe || "";
    const identificacionRecibePrevio = resultado.identificacionRecibe || "";

    const { value: datosRecibe } = await MySwal.fire({
      title: "REGISTRAR ENTREGA DE RESULTADOS",
      width: "50%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
        confirmButton: "btnConfirmGreen",
      },
      html: `
        <div style="display:flex;flex-direction:column;gap:1vw;text-align:left;padding: 0.5vw 1vw;">
          <div style="display:flex;flex-direction:column;gap:0.35rem;">
            <label for="swal-nombreRecibe" style="font-weight:700;font-size:0.95vw;">
              Nombre completo de la persona que recoge <span style="color:red;">*</span>:
            </label>
            <input 
              id="swal-nombreRecibe" 
              class="input-swal" 
              placeholder="Nombre completo" 
              value="${nombreRecibePrevio}" 
              style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;" 
            />
          </div>
          <div style="display:flex;flex-direction:column;gap:0.35rem;">
            <label for="swal-identificacionRecibe" style="font-weight:700;font-size:0.95vw;">
              Número de identificación de la persona que recoge:
            </label>
            <input 
              id="swal-identificacionRecibe" 
              class="input-swal" 
              placeholder="IFE, INE, Pasaporte, etc." 
              value="${identificacionRecibePrevio}" 
              style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;" 
            />
          </div>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const nombreRecibe = document.getElementById("swal-nombreRecibe")?.value?.trim();
        const identificacionRecibe = document.getElementById("swal-identificacionRecibe")?.value?.trim();

        if (!nombreRecibe) {
          Swal.showValidationMessage("El nombre completo de la persona que recoge es obligatorio");
          return false;
        }

        return { nombreRecibe, identificacionRecibe };
      }
    });

    if (datosRecibe) {
      try {
        const res = await SolicitudesService.updateSolicitudRecibe(datosRecibe, resultado.idSolicitud);
        if (res?.data?.estatus === "OK") {
          mostrarMensaje("Entrega de resultados registrada correctamente", fetchSolicitudes);
        } else {
          mostrarError(res?.data?.mensaje || "Error al registrar la entrega");
        }
      } catch (error) {
        console.error("Error al registrar la entrega:", error);
        mostrarError("Error inesperado al guardar los datos de entrega.");
      }
    }
  }

  async function handlePagarSolicitud(resultado) {
    if (!resultado || !resultado.idSolicitud) return;

    try {
      const cajaRes = await CajaService.getCajaPorSolicitud(resultado.idSolicitud);
      const payload = cajaRes?.data ?? cajaRes;
      const items = Array.isArray(payload?.caja) ? payload.caja : (Array.isArray(payload) ? payload : []);
      const datosCaja = items[0] ?? payload?.caja?.[0] ?? payload?.[0] ?? payload;

      const restanteMonto = Number(
        datosCaja?.adeudo ??
        datosCaja?.saldoPendiente ??
        datosCaja?.restante ??
        datosCaja?.saldo ??
        datosCaja?.pendiente ??
        datosCaja?.deuda ??
        0
      );

      if (restanteMonto <= 0) {
        mostrarMensaje("Esta solicitud ya se encuentra completamente pagada.");
        return;
      }

      const nombrePaciente = `${resultado.nombrePaciente || ""} ${resultado.apPaternoPaciente || ""} ${resultado.apMaternoPaciente || ""}`.trim();
      const codigoOrden = resultado.orden || resultado.codigo || "";

      const { value: pagoNuevo } = await MySwal.fire({
        title: "REGISTRAR PAGO DE SOLICITUD",
        width: "60%",
        customClass: {
          title: "tituloDegradado",
          popup: "swalMaxHeight",
          confirmButton: "btnConfirmGreen",
        },
        html: `
          <div style="display:flex;flex-direction:column;gap:1vw;text-align:left;padding: 0.5vw 1vw;">
            <div style="background-color:#f1f5f9;border-left:4px solid #18234f;padding:0.75rem;border-radius:4px;margin-bottom:0.5rem;font-size:0.9rem;">
              <div><strong>Paciente:</strong> ${nombrePaciente}</div>
              <div style="margin-top:0.25rem;"><strong>Orden:</strong> #${codigoOrden}</div>
            </div>
            
            <div class="tituloDegradado" style="font-size:1rem;padding:0.55vw 0.7vw;border-radius:8px;display:block;width:100%;text-align:center;font-weight:700;">TOTAL A PAGAR</div>
            <div style="font-size:1.7rem;padding:0.3vw 0.5vw;border-radius:8px;display:block;text-align:center;font-weight:800;color:#2e7d32;">$${restanteMonto.toFixed(2)}</div>
            
            <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:1rem;margin-bottom:0.5vw;">
              <div style="display:flex;flex-direction:column;gap:0.35rem;">
                <label for="swal-formaPago" style="font-weight:700;font-size:0.95vw;">Forma de Pago:</label>
                <select class="swal-formaPago" id="swal-formaPago" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;">
                  <option value="efectivo">Efectivo</option>
                  <option value="debito">Tarjeta de débito</option>
                  <option value="credito">Tarjeta de crédito</option>
                  <option value="cheque">Cheque</option>
                  <option value="transferencia">Transferencia</option>
                </select>
              </div>
              <div id="swal-ultimos4-group" style="display:none;flex-direction:column;gap:0.35rem;">
                <label for="swal-ultimos4" style="font-weight:700;font-size:0.95vw;">Últimos 4 dígitos:</label>
                <input id="swal-ultimos4" class="input-swal" placeholder="0000" maxlength="4" inputmode="numeric" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;" />
              </div>
              <div style="display:flex;flex-direction:column;gap:0.35rem;">
                <label for="swal-cantidad" style="font-weight:700;font-size:0.95vw;">Cantidad recibida:</label>
                <input id="swal-cantidad" class="input-swal" placeholder="0.00" type="number" step="0.01" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;" />
              </div>
              <div style="display:flex;flex-direction:column;gap:0.35rem;">
                <label for="swal-imprimirTicket" style="font-weight:700;font-size:0.95vw;">¿Imprimir ticket?:</label>
                <select id="swal-imprimirTicket" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;">
                  <option value="si">Sí</option>
                  <option value="no">No</option>
                </select>
              </div>
            </div>
            
            <div style="display:flex;flex-direction:column;align-items:center;gap:0.25rem;justify-content:center;max-width:220px;margin:0 auto;width:100%;">
              <label for="swal-cambio" style="font-weight:700;font-size:0.8vw;">Cambio:</label>
              <div id="swal-cambio" style="min-height:2rem;display:flex;align-items:center;justify-content:center;padding:0.45vw 0.6vw;font-size:0.85vw;border:1px solid #cfd8dc;border-radius:6px;background:#f7f9fc;font-weight:700;color:#18234f;width:100%;"> </div>
            </div>
          </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Pagar",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          const select = document.getElementById("swal-formaPago");
          const ultimos4Group = document.getElementById("swal-ultimos4-group");
          const cantidadInput = document.getElementById("swal-cantidad");
          const cambioLabel = document.getElementById("swal-cambio");

          const actualizarCambio = () => {
            const recibido = parseFloat(cantidadInput.value) || 0;
            const cambio = recibido - restanteMonto;
            cambioLabel.textContent = cambio > 0 ? `$${cambio.toFixed(2)}` : "";
          };

          const actualizarUltimos4 = () => {
            const value = select.value;
            ultimos4Group.style.display = ["debito", "credito", "cheque", "transferencia"].includes(value) ? "flex" : "none";
          };

          select.addEventListener("change", () => {
            actualizarUltimos4();
            actualizarCambio();
          });

          cantidadInput.addEventListener("input", actualizarCambio);
          actualizarUltimos4();
          actualizarCambio();
        },
        preConfirm: () => {
          const formaPago = document.getElementById("swal-formaPago")?.value?.trim();
          const ultimos4 = document.getElementById("swal-ultimos4")?.value?.trim();
          const cantidad = document.getElementById("swal-cantidad")?.value?.trim();
          const imprimirTicket = document.getElementById("swal-imprimirTicket")?.value?.trim();

          if (!formaPago || !cantidad) {
            Swal.showValidationMessage("La forma de pago y la cantidad son obligatorias");
            return false;
          }
          return { formaPago, ultimos4, cantidad, imprimirTicket };
        },
      });

      if (pagoNuevo) {
        let formaPagoN = pagoNuevo.formaPago;
        if (pagoNuevo.formaPago === "debito" || pagoNuevo.formaPago === "credito") {
          formaPagoN = "tarjeta";
        }

        function getFormattedNowLocal() {
          const now = new Date();
          const dd = String(now.getDate()).padStart(2, "0");
          const mm = String(now.getMonth() + 1).padStart(2, "0");
          const yyyy = now.getFullYear();
          const hours = String(now.getHours()).padStart(2, "0");
          const minutes = String(now.getMinutes()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd} ${hours}:${minutes}`;
        }

        const pagoBody = {
          formaPago: formaPagoN,
          ultimos4: pagoNuevo.ultimos4 || "",
          cantidad: Math.min(parseFloat(pagoNuevo.cantidad) || 0, restanteMonto),
          idSolicitud: resultado.idSolicitud,
          cobro: currentU?.id,
          fechaCobro: getFormattedNowLocal(),
        };

        const res = await CajaService.pagarSolicitud(pagoBody);

        if (res?.data?.estatus === "OK") {
          try {
            const printHist = await HistorialEstudiosService.getHistorialSolicitudImpresionEnvio(resultado.idSolicitud);
            const totalStudiesRes = await SolicitudesEstudiosService.getEstudiosPorSolicitud(resultado.idSolicitud);
            const totalEstudiosList = Array.isArray(totalStudiesRes)
              ? totalStudiesRes
              : totalStudiesRes?.estudios || totalStudiesRes?.data || [];

            const getEstudioID = (st) => String(st.idEstudio || st.id_estudio || st.idEstudioPadre || st.id || st.estudio_id || 0);
            const printedEstudioIds = new Set((printHist || []).map(h => String(h.idEstudio || h.id_estudio || h.id)));
            const todosEstudiosImpresos = totalEstudiosList.length > 0 && totalEstudiosList.every(st => {
              const stId = getEstudioID(st);
              return stId !== "0" && printedEstudioIds.has(stId);
            });

            const esPagoCompleto = (parseFloat(pagoNuevo.cantidad) || 0) >= (restanteMonto - 0.01);

            if (esPagoCompleto && todosEstudiosImpresos) {
              try {
                await SolicitudesService.updateEstatusSolicitud(resultado.idSolicitud, "EN");
              } catch (eUpd) {
                console.warn("Fallback updateSolicitud tradicional tras pago:", eUpd);
                await SolicitudesService.updateSolicitud({
                  solicitud: { ...resultado, estatusResultados: "EN", estatus: "P" },
                  estudios: totalEstudiosList
                }, resultado.idSolicitud);
              }
              await HistorialService.registrarEvento({
                idSolicitud: resultado.idSolicitud,
                nombreEmpleado: currentU?.nombre || "EMPLEADO",
                operacion: "Solicitud marcada como Entregada (EN) al liquidarse el pago tras haberse impreso previamente todos sus estudios"
              });
            }
          } catch (ePaid) {
            console.error("Error al verificar entrega tras pago:", ePaid);
          }

          if (pagoNuevo.imprimirTicket === "si") {
            try {
              const { blob } = await generarTicketPago(resultado);
              const ticketUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
              await Swal.fire({
                title: "Ticket de Pago",
                html: `<iframe src="${ticketUrl}" width="100%" height="520px" style="border:none;"></iframe>`,
                width: "55%",
                showCloseButton: true,
                showConfirmButton: false,
              });
              URL.revokeObjectURL(ticketUrl);
            } catch (ticketErr) {
              console.error("Error al generar ticket de pago:", ticketErr);
            }
            fetchSolicitudes();
          } else {
            mostrarMensaje("Pago realizado correctamente.", fetchSolicitudes);
          }
        } else {
          mostrarError(res?.data?.mensaje || "No se pudo registrar el pago.");
        }
      }
    } catch (err) {
      console.error("Error in handlePagarSolicitud:", err);
      mostrarError("Error al registrar el pago.");
    }
  }

  const handleTabEntregasChange = (event, newValue) => {
    setActiveTabEntregas(newValue);
    saveEntregasState({ activeTabEntregas: newValue });
  };

  useEffect(() => {
    fetchSolicitudes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const coincideBusquedaTexto = (sol, texto) => {
    if (!texto) return true;
    const term = texto.toLowerCase().trim();
    const codigo = String(sol.orden || sol.codigo || "").toLowerCase();
    const paciente = `${sol.nombrePaciente || ""} ${sol.apPaternoPaciente || ""} ${sol.apMaternoPaciente || ""}`.toLowerCase();
    const empresa = String(sol.nombreConvenio || "").toLowerCase();
    return codigo.includes(term) || paciente.includes(term) || empresa.includes(term);
  };

  const esFechaEnRango = (fechaStr, rango) => {
    if (!rango || rango === "todos") return true;
    if (!fechaStr) return false;
    const fecha = new Date(fechaStr);
    if (Number.isNaN(fecha.getTime())) return true;
    const hoy = new Date();
    const limite = new Date();
    if (rango === "3m") {
      limite.setMonth(hoy.getMonth() - 3);
    } else if (rango === "6m") {
      limite.setMonth(hoy.getMonth() - 6);
    } else if (rango === "1y") {
      limite.setFullYear(hoy.getFullYear() - 1);
    }
    return fecha.getTime() >= limite.getTime();
  };

  const getTimeStampSolicitud = (sol) => {
    const fStr = sol.fecha || sol.fechaSolicitud || sol.fechaCreacion || sol.createdAt || sol.created_at || sol.fechaEntrega;
    if (fStr) {
      const dateVal = new Date(typeof fStr === "string" ? fStr.replace(/-/g, "/") : fStr);
      if (!Number.isNaN(dateVal.getTime())) return dateVal.getTime();
    }
    return Number(sol.idSolicitud || sol.id || sol.orden || 0);
  };

  const filtrarSolicitudes = (lista) => {
    return lista
      .filter(sol => {
        if (sol.estadoSolicitud === "C") return false;

        const coincideTexto = coincideBusquedaTexto(sol, filtroTexto);
        if (!coincideTexto) return false;

        const coincideFecha = esFechaEnRango(sol.fecha || sol.fechaEntrega, filtroFecha);
        if (!coincideFecha) return false;

        const term = filtroTexto.trim();
        if (!term) {
          return sol.estadoSolicitud === "L";
        }

        return true;
      })
      .sort((a, b) => {
        const timeA = getTimeStampSolicitud(a);
        const timeB = getTimeStampSolicitud(b);
        if (timeB !== timeA) return timeB - timeA;
        return Number(b.idSolicitud || b.orden || 0) - Number(a.idSolicitud || a.orden || 0);
      });
  };

  const handleLimpiarFiltros = () => {
    setFiltroTexto("");
    setFiltroFecha("3m");
    setMostrarTabla(true);
  };

  const formatFecha = (fecha) => {
    if (!fecha) return "";
    const date = new Date(fecha.replace(/-/g, "/"));
    if (Number.isNaN(date.getTime())) return fecha;
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ];
    return `${date.getDate()} de ${meses[date.getMonth()]} del ${date.getFullYear()}`;
  };

  const formatEstadoSolicitud = (estado) => {
    if (estado === "E" || estado === "P") return "En Proceso";
    if (estado === "R") return "Reportado";
    if (estado === "V") return "Revisado";
    if (estado === "L") return "Liberado";
    if (estado === "EN") return "Entregado";
    if (estado === "RP") return "Resultados Parciales";
    return estado || "";
  };

  const getEstadoSolicitudChipStyles = (estado) => {
    if (estado === "E" || estado === "P") {
      return {
        backgroundColor: "#000",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "R") {
      return {
        backgroundColor: "#ff9800",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "V") {
      return {
        backgroundColor: "#2196f3",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "L") {
      return {
        backgroundColor: "#4caf50",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "EN") {
      return {
        backgroundColor: "#4caf50",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "RP") {
      return {
        backgroundColor: "#ffb300",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    return {
      backgroundColor: "#e0e0e0",
      color: "#000",
      fontWeight: 700,
      borderRadius: "8px",
    };
  };

  const TabPanel = ({ children, value, index }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );

  const renderTablaSolicitudes = (lista, esEntregadosTab) => {
    if (loadingTabla) {
      return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "35vh", py: 5 }}>
          <CircularProgress size={50} sx={{ color: "#18234f", mb: 2 }} />
          <Typography sx={{ fontSize: "1.1rem", fontWeight: "bold", color: "#18234f" }}>
            Cargando entregas...
          </Typography>
        </Box>
      );
    }

    const itemsPorPagina = 10;
    const totalPaginas = Math.ceil(lista.length / itemsPorPagina) || 1;
    const currentPage = Math.min(paginaActual, totalPaginas);
    const startIdx = (currentPage - 1) * itemsPorPagina;
    const endIdx = startIdx + itemsPorPagina;
    const listaPaginada = lista.slice(startIdx, endIdx);

    // Pre-cargar estudios únicamente de los 10 registros visibles para respuesta instantánea al primer clic
    listaPaginada.forEach((resultado) => {
      const key = String(resultado.idSolicitud || resultado.orden);
      if (resultado.idSolicitud && !estudiosPorSolicitud[key] && !estudiosPorSolicitud[resultado.orden] && !loadingEstudios[key]) {
        fetchEstudiosForSolicitud(resultado.orden, resultado.idSolicitud);
      }
    });

    return (
      <Box sx={{ transform: "scale(0.92)", transformOrigin: "top left", width: "108.7%", marginRight: "-8.7%" }}>
        <Typography sx={{ color: "red", fontWeight: "bold", mb: 2, fontSize: "0.95rem" }}>
          NOTA: Los resultados del paciente se darán por entregados una vez que hayan impreso todos sus estudios.
        </Typography>
        <Table sx={{ width: "100%", backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
          <TableHead sx={{ backgroundColor: "#18234f" }}>
            <TableRow>
              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Ver
              </TableCell>
              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Sucursal
              </TableCell>
              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Orden
              </TableCell>
              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Fecha de entrega
              </TableCell>
              <TableCell align="left" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Nombre del paciente
              </TableCell>
              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Estado de la Solicitud
              </TableCell>
              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Recibe Resultados
              </TableCell>

              {!esEntregadosTab && (
                <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                  Registrar Pago
                </TableCell>
              )}

              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Impr/Desc Exámenes/Archivos
              </TableCell>
              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Enviar por Correo
              </TableCell>
              <TableCell align="center" sx={{ color: "white", fontWeight: "bold", borderBottom: "none", fontSize: "0.9vw", py: 1 }}>
                Historial Impresión Envío
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listaPaginada.length > 0 ? (
              listaPaginada.map((resultado, index) => {
                const key = String(resultado.idSolicitud || resultado.orden);
                const isExpanded = !!expandedSolicitudes[key] || !!expandedSolicitudes[resultado.orden];
                const studies = estudiosPorSolicitud[key] || estudiosPorSolicitud[resultado.orden] || [];
                const isLoading = !!loadingEstudios[key] || !!loadingEstudios[resultado.orden];

                return (
                  <React.Fragment key={index}>
                    <TableRow>
                      {/* 1. Ver */}
                      <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                        <IconButton
                          sx={{ color: "#1976d2" }}
                          onClick={() => handleToggleExpand(resultado.orden, resultado.idSolicitud)}
                        >
                          {isExpanded ? (
                            <KeyboardArrowDownIcon sx={{ fontSize: "1.5rem" }} />
                          ) : (
                            <ArrowForwardIosIcon sx={{ fontSize: "1.2rem" }} />
                          )}
                        </IconButton>
                      </TableCell>

                      {/* 2. Sucursal */}
                      <TableCell
                        align="center"
                        onClick={() => handleToggleExpand(resultado.orden, resultado.idSolicitud)}
                        sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5, cursor: "pointer" }}
                      >
                        <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "0.8rem", cursor: "pointer" }}>
                          {resultado.sucursal || resultado.nombreSucursal || ""}
                        </Typography>
                      </TableCell>

                      {/* 3. Orden */}
                      <TableCell
                        align="center"
                        onClick={() => handleToggleExpand(resultado.orden, resultado.idSolicitud)}
                        sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5, cursor: "pointer" }}
                      >
                        <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "0.8rem", cursor: "pointer" }}>
                          {resultado.orden || resultado.codigo || ""}
                        </Typography>
                      </TableCell>

                      {/* 4. Fecha de entrega */}
                      <TableCell
                        align="center"
                        onClick={() => handleToggleExpand(resultado.orden, resultado.idSolicitud)}
                        sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5, cursor: "pointer" }}
                      >
                        <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "0.8rem", cursor: "pointer" }}>
                          {formatFecha(resultado.fechaEntrega)}
                        </Typography>
                      </TableCell>

                      {/* 6. Nombre del paciente */}
                      <TableCell
                        align="left"
                        onClick={() => handleToggleExpand(resultado.orden, resultado.idSolicitud)}
                        sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5, cursor: "pointer" }}
                      >
                        <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "0.8rem", cursor: "pointer" }}>
                          {`${resultado.nombrePaciente || ""} ${resultado.apPaternoPaciente || ""} ${resultado.apMaternoPaciente || ""}`}
                          {resultado.nombreConvenio && (
                            <Box component="span" sx={{ fontWeight: "normal", color: "#666", ml: 1 }}>
                              ({resultado.nombreConvenio})
                            </Box>
                          )}
                        </Typography>
                      </TableCell>

                      {/* 7. Estado de la solicitud */}
                      <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                        <Chip
                          label={formatEstadoSolicitud(resultado.estadoSolicitud)}
                          sx={getEstadoSolicitudChipStyles(resultado.estadoSolicitud)}
                          size="small"
                        />
                      </TableCell>

                      {/* 8. Recibe resultados */}
                      <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                        <IconButton
                          sx={{ color: "#1976d2" }}
                          onClick={() => handleRecibeResultados(resultado)}
                        >
                          <Box sx={{ position: "relative", display: "inline-flex" }}>
                            <VisibilityIcon sx={{ fontSize: "1.5rem", color: "#1976d2" }} />
                            <AssignmentIcon sx={{
                              fontSize: "0.9rem",
                              color: "#18234f",
                              position: "absolute",
                              bottom: -4,
                              right: -4,
                              backgroundColor: "white",
                              borderRadius: "2px",
                              padding: "1px"
                            }} />
                          </Box>
                        </IconButton>
                      </TableCell>

                      {/* 9. Registrar pago */}
                      {!esEntregadosTab && (
                        <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                          {resultado.pagado ? (
                            <Chip
                              label="Pagado"
                              size="small"
                              sx={{
                                backgroundColor: "#e8f5e9",
                                color: "#2e7d32",
                                fontWeight: "bold",
                                borderRadius: "8px",
                                border: "1px solid #a5d6a7",
                              }}
                            />
                          ) : (
                            <IconButton
                              sx={{ color: "#4caf50" }}
                              onClick={() => handlePagarSolicitud(resultado)}
                            >
                              <PaymentsIcon sx={{ fontSize: "1.5rem" }} />
                            </IconButton>
                          )}
                        </TableCell>
                      )}

                      {/* 10. Imprimir/Descargar */}
                      <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleImprimirSolicitud(resultado, studies)}
                            sx={{
                              backgroundColor: "#c62828",
                              color: "white",
                              minWidth: "35px",
                              width: "35px",
                              height: "28px",
                              p: 0,
                              "&:hover": { backgroundColor: "#b71c1c" }
                            }}
                          >
                            <PrintIcon sx={{ fontSize: "1.1rem" }} />
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleDescargarPdfSolicitud(resultado, studies)}
                            sx={{
                              backgroundColor: "#4caf50",
                              color: "white",
                              minWidth: "35px",
                              width: "35px",
                              height: "28px",
                              p: 0,
                              "&:hover": { backgroundColor: "#388e3c" }
                            }}
                          >
                            <PictureAsPdfIcon sx={{ fontSize: "1.1rem" }} />
                          </Button>
                        </Box>
                      </TableCell>

                      {/* 11. Enviar por correo */}
                      <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleEnviarCorreoInforme(resultado)}
                              sx={{
                                backgroundColor: "#ffb300",
                                color: "white",
                                minWidth: "35px",
                                width: "35px",
                                height: "28px",
                                p: 0,
                                "&:hover": { backgroundColor: "#ff8f00" }
                              }}
                            >
                              <MailIcon sx={{ fontSize: "1.1rem" }} />
                            </Button>
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleEnviarInformeWhatsApp(resultado)}
                              sx={{
                                backgroundColor: "#25d366",
                                color: "white",
                                minWidth: "35px",
                                width: "35px",
                                height: "28px",
                                p: 0,
                                "&:hover": { backgroundColor: "#128c7e" }
                              }}
                            >
                              <WhatsAppIcon sx={{ fontSize: "1.1rem" }} />
                            </Button>
                          </Box>
                          {/* Chip rojo con icono de usuario diciendo "Si" si se envía al paciente por correo y/o whatsapp */}
                          {(resultado.enviarEmail === "si" || resultado.enviarWhatsapp === "si") && (
                            <Chip
                              icon={<PersonIcon sx={{ color: "white !important", fontSize: "0.9rem" }} />}
                              label="Si"
                              size="small"
                              sx={{
                                backgroundColor: "#d32f2f",
                                color: "white",
                                fontWeight: "bold",
                                fontSize: "0.7rem",
                                height: "20px",
                                mt: 0.5,
                                "& .MuiChip-icon": { color: "white" }
                              }}
                            />
                          )}
                          {/* Chip pequeño con preferencias de envío */}
                          {(resultado.enviarEmail === "si" || resultado.enviarWhatsapp === "si" || resultado.enviarEmailD === "si" || resultado.enviarWhatsappD === "si") && (
                            <Box sx={{ display: "flex", gap: 0.5, mt: 0.5 }}>
                              {(resultado.enviarEmail === "si" || resultado.enviarEmailD === "si") && (
                                <Chip label="Correo" size="small" sx={{ fontSize: "0.6rem", height: "14px", backgroundColor: "#fff9c4", color: "#f57f17", fontWeight: "bold" }} />
                              )}
                              {(resultado.enviarWhatsapp === "si" || resultado.enviarWhatsappD === "si") && (
                                <Chip label="WhatsApp" size="small" sx={{ fontSize: "0.6rem", height: "14px", backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: "bold" }} />
                              )}
                            </Box>
                          )}
                        </Box>
                      </TableCell>

                      {/* 12. Historial Impresión Envío */}
                      <TableCell align="center" sx={{ borderBottom: "1px solid #ccc", py: 0.5 }}>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleHistorialImpresionEnvio(resultado)}
                          sx={{
                            backgroundColor: "#4caf50",
                            color: "white",
                            minWidth: "40px",
                            width: "40px",
                            height: "30px",
                            p: 0,
                            "&:hover": {
                              backgroundColor: "#388e3c"
                            }
                          }}
                        >
                          <VisibilityIcon sx={{ fontSize: "1.2rem" }} />
                        </Button>
                      </TableCell>
                    </TableRow>
                    {resultado.nombreRecibe && (
                      <TableRow>
                        <TableCell colSpan={esEntregadosTab ? 11 : 12} sx={{ backgroundColor: "#18234f", color: "white", py: 1, px: 2 }}>
                          <Typography sx={{ fontSize: "0.85rem", fontWeight: "bold" }}>
                            "{resultado.nombreRecibe}" con identificación "{resultado.identificacionRecibe || "Sin identificación"}" recogió los resultados del paciente.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow sx={{ backgroundColor: isExpanded ? "#f9f9f9" : "transparent" }}>
                      <TableCell colSpan={esEntregadosTab ? 11 : 12} sx={{ p: 0, borderBottom: isExpanded ? "1px solid #ccc" : "none" }}>
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          <Box sx={{ p: 2 }}>
                            <Box sx={{ width: "95%", mx: "auto", my: 1, borderRadius: "8px", overflow: "hidden", border: "1px solid #ccc", boxShadow: "0px 2px 4px rgba(0,0,0,0.08)" }}>
                              {isLoading ? (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 3, backgroundColor: "#fff" }}>
                                  <Typography sx={{ fontWeight: 500, color: "#18234f" }}>Cargando estudios...</Typography>
                                </Box>
                              ) : studies.length > 0 ? (
                                <Table size="small" sx={{ width: "100%", backgroundColor: "#fff" }}>
                                  <TableHead sx={{ backgroundColor: "#d0e1eb" }}>
                                    <TableRow>
                                      <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Código</TableCell>
                                      <TableCell align="left" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Estudio</TableCell>
                                      <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Seleccionar estudio para impresion</TableCell>
                                      <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderBottom: "1px solid #ccc", py: 1.5 }}>Historial de modificaciones</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {studies.map((study, sIdx) => {
                                      const selectKey = `${resultado.idSolicitud}-${study.idEstudio}`;
                                      const isSelected = !!selectedEstudios[selectKey];
                                      return (
                                        <React.Fragment key={sIdx}>
                                          <TableRow sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}>
                                            <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", fontWeight: "bold", py: 1.5 }}>
                                              {study.codigo || study.idEstudio}
                                            </TableCell>
                                            <TableCell align="left" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", fontWeight: "bold", textTransform: "uppercase", py: 1.5 }}>
                                              {study.nombre || study.nombreEstudio || ""}
                                            </TableCell>
                                            <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>
                                              <input
                                                type="checkbox"
                                                checked={isSelected}
                                                onChange={() => handleToggleSelectEstudio(resultado.idSolicitud, study.idEstudio, study.subExamenes)}
                                                style={{ transform: "scale(1.2)", cursor: "pointer" }}
                                              />
                                            </TableCell>

                                            <TableCell align="center" sx={{ borderBottom: "1px solid #ccc", py: 0.5 }}>
                                              <Button
                                                variant="contained"
                                                size="small"
                                                onClick={() => handleHistorialModificaciones(resultado, study)}
                                                sx={{
                                                  backgroundColor: "#4caf50",
                                                  color: "white",
                                                  minWidth: "40px",
                                                  width: "40px",
                                                  height: "30px",
                                                  p: 0,
                                                  "&:hover": { backgroundColor: "#388e3c" }
                                                }}
                                              >
                                                <VisibilityIcon sx={{ fontSize: "1.2rem" }} />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                          {study.registroExamenSub && (study.subExamenes || []).map((sub, subIdx) => {
                                            const subSelectKey = `${resultado.idSolicitud}-${sub.idEstudio}`;
                                            const isSubSelected = !!selectedEstudios[subSelectKey];
                                            return (
                                              <TableRow key={`sub-${subIdx}`} sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}>
                                                <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1 }}>
                                                  {sub.codigo || ""}
                                                </TableCell>
                                                <TableCell align="left" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1 }}>
                                                  <span style={{ marginLeft: "1.5vw", textTransform: "uppercase" }}>{sub.nombre}</span>
                                                </TableCell>
                                                <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1 }}>
                                                  <input
                                                    type="checkbox"
                                                    checked={isSubSelected}
                                                    onChange={() => handleToggleSelectEstudio(resultado.idSolicitud, sub.idEstudio, null, study.idEstudio)}
                                                    style={{ transform: "scale(1.1)", cursor: "pointer" }}
                                                  />
                                                </TableCell>
                                                <TableCell align="center" sx={{ borderBottom: "1px solid #ccc", py: 1 }}>
                                                  -
                                                </TableCell>
                                              </TableRow>
                                            );
                                          })}
                                        </React.Fragment>
                                      );
                                    })}
                                    {/* Fila final de botones */}
                                    <TableRow>
                                      <TableCell colSpan={2} align="left" sx={{ borderRight: "1px solid #ccc", py: 1.5, fontWeight: "bold", color: "#666" }}>
                                        Para imprimir/descargar/enviar por correo algun estudio seleccionelo y de clic en el boton correspondiente
                                      </TableCell>
                                      <TableCell colSpan={2} align="center" sx={{ py: 1.5 }}>
                                        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center" }}>
                                          <Button
                                            variant="contained"
                                            size="small"
                                            onClick={() => {
                                              let allItems = [];
                                              studies.forEach(st => {
                                                allItems.push(st);
                                                if (st.registroExamenSub && (st.subExamenes || []).length > 0) {
                                                  st.subExamenes.forEach(sub => allItems.push(sub));
                                                }
                                              });
                                              const seleccionados = allItems.filter(s => selectedEstudios[`${resultado.idSolicitud}-${s.idEstudio}`]);
                                              handleImprimirSolicitud(resultado, seleccionados.length > 0 ? seleccionados : studies);
                                            }}
                                            sx={{
                                              backgroundColor: "#d32f2f",
                                              color: "white",
                                              minWidth: "35px",
                                              width: "35px",
                                              height: "28px",
                                              p: 0,
                                              "&:hover": { backgroundColor: "#c62828" }
                                            }}
                                          >
                                            <PrintIcon sx={{ fontSize: "1.1rem" }} />
                                          </Button>
                                          <Button
                                            variant="contained"
                                            size="small"
                                            onClick={() => {
                                              let allItems = [];
                                              studies.forEach(st => {
                                                allItems.push(st);
                                                if (st.registroExamenSub && (st.subExamenes || []).length > 0) {
                                                  st.subExamenes.forEach(sub => allItems.push(sub));
                                                }
                                              });
                                              const seleccionados = allItems.filter(s => selectedEstudios[`${resultado.idSolicitud}-${s.idEstudio}`]);
                                              handleDescargarPdfSolicitud(resultado, seleccionados.length > 0 ? seleccionados : studies);
                                            }}
                                            sx={{
                                              backgroundColor: "#4caf50",
                                              color: "white",
                                              minWidth: "35px",
                                              width: "35px",
                                              height: "28px",
                                              p: 0,
                                              "&:hover": { backgroundColor: "#388e3c" }
                                            }}
                                          >
                                            <PictureAsPdfIcon sx={{ fontSize: "1.1rem" }} />
                                          </Button>
                                          <Button
                                            variant="contained"
                                            size="small"
                                            onClick={() => {
                                              let allItems = [];
                                              studies.forEach(st => {
                                                allItems.push(st);
                                                if (st.registroExamenSub && (st.subExamenes || []).length > 0) {
                                                  st.subExamenes.forEach(sub => allItems.push(sub));
                                                }
                                              });
                                              const seleccionados = allItems.filter(s => selectedEstudios[`${resultado.idSolicitud}-${s.idEstudio}`]);
                                              handleEnviarCorreoInforme(resultado, seleccionados.length > 0 ? seleccionados : studies);
                                            }}
                                            sx={{
                                              backgroundColor: "#ffb300",
                                              color: "white",
                                              minWidth: "35px",
                                              width: "35px",
                                              height: "28px",
                                              p: 0,
                                              "&:hover": { backgroundColor: "#ff8f00" }
                                            }}
                                          >
                                            <MailIcon sx={{ fontSize: "1.1rem" }} />
                                          </Button>
                                          <Button
                                            variant="contained"
                                            size="small"
                                            onClick={() => {
                                              let allItems = [];
                                              studies.forEach(st => {
                                                allItems.push(st);
                                                if (st.registroExamenSub && (st.subExamenes || []).length > 0) {
                                                  st.subExamenes.forEach(sub => allItems.push(sub));
                                                }
                                              });
                                              const seleccionados = allItems.filter(s => selectedEstudios[`${resultado.idSolicitud}-${s.idEstudio}`]);
                                              handleEnviarInformeWhatsApp(resultado, seleccionados.length > 0 ? seleccionados : studies);
                                            }}
                                            sx={{
                                              backgroundColor: "#25d366",
                                              color: "white",
                                              minWidth: "35px",
                                              width: "35px",
                                              height: "28px",
                                              p: 0,
                                              "&:hover": { backgroundColor: "#128c7e" }
                                            }}
                                          >
                                            <WhatsAppIcon sx={{ fontSize: "1.1rem" }} />
                                          </Button>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              ) : (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 3, backgroundColor: "#fff" }}>
                                  <Typography sx={{ fontWeight: 500, color: "#666" }}>No hay estudios en esta solicitud.</Typography>
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={esEntregadosTab ? 11 : 12} align="center" sx={{ py: 4 }}>
                  No hay registros
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {totalPaginas > 1 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5vw",
              marginTop: "1.5vw",
              marginBottom: "1vw",
            }}
          >
            <IconButton
              onClick={() => setPaginaActual((prev) => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
              sx={{
                backgroundColor: "#f0f0f0",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d9eaf7" },
                "&.Mui-disabled": { backgroundColor: "#f5f5f5", color: "#ccc" },
                borderRadius: "8px",
                padding: "0.5vw",
              }}
            >
              <ArrowBackIosIcon sx={{ fontSize: "1vw", marginLeft: "0.3vw" }} />
            </IconButton>

            {(() => {
              let startPage = 1;
              if (currentPage >= 10) {
                startPage = 1 + 5 * Math.floor((currentPage - 5) / 5);
              }
              const endPage = Math.min(totalPaginas, startPage + 9);

              const buttons = [];
              for (let i = startPage; i <= endPage; i++) {
                const isActive = i === currentPage;
                buttons.push(
                  <Button
                    key={i}
                    onClick={() => setPaginaActual(i)}
                    sx={{
                      minWidth: "2.5vw",
                      height: "2.5vw",
                      backgroundColor: isActive ? "#014e65" : "#f0f0f0",
                      color: isActive ? "white" : "black",
                      fontWeight: "bold",
                      fontSize: "0.9vw",
                      borderRadius: "8px",
                      border: "none",
                      "&:hover": {
                        backgroundColor: isActive ? "#013240" : "#d9eaf7",
                      },
                      padding: 0,
                    }}
                  >
                    {i}
                  </Button>
                );
              }
              return buttons;
            })()}

            <IconButton
              onClick={() => setPaginaActual((prev) => Math.min(totalPaginas, prev + 1))}
              disabled={currentPage === totalPaginas}
              sx={{
                backgroundColor: "#f0f0f0",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d9eaf7" },
                "&.Mui-disabled": { backgroundColor: "#f5f5f5", color: "#ccc" },
                borderRadius: "8px",
                padding: "0.5vw",
              }}
            >
              <ArrowForwardIosIcon sx={{ fontSize: "1vw" }} />
            </IconButton>
          </Box>
        )}
      </Box>
    );
  };

  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
            width: "100%",
          }}
        >
          <Stack spacing={2} sx={{ width: "100%", pl: "3vw", pr: "10vw", boxSizing: "border-box" }}>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "100%", boxSizing: "border-box" }}
              className="paperFiltrosEntregas"
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h9"
                    gutterBottom
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      whiteSpace: "pre-line",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ fontWeight: "bold", justifyContent: "center" }}
                    >
                      ENTREGA DE INFORME DE RESULTADOS
                    </Box>
                  </Typography>
                </Box>
              </Grid>

              {/* Contenedor principal */}
              <Grid container spacing={"0.3vw"}>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{
                    paddingTop: "0.6vw",
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <Stack direction="row" spacing={"3vw"} sx={{ width: "100%" }}>
                    <Grid item xs={12} sx={{ width: "100%" }}>
                      <Table sx={{ width: "100%", backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                        {" "}
                        <TableHead sx={{ backgroundColor: "#18234f" }}>
                          <TableRow>
                            <TableCell
                              colSpan={4}
                              align="center"
                              sx={{
                                fontSize: "1.5vw",
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              Filtros
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody
                          sx={{
                            "& .MuiTableCell-root": { padding: "4px 6px" },
                          }}
                        >
                          <TableRow>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography
                                  variant="h9"
                                  gutterBottom
                                  sx={{
                                    fontWeight: "bold",
                                    color: "black",
                                    padding: "0.5vw 1vw",
                                    borderRadius: "8px",
                                    display: "inline-block",

                                    textAlign: "center",
                                  }}
                                >
                                  Coloque el codigo de la solicitud, nombre del
                                  paciente o nombre de empresa:
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <TextField
                                  disabled={viewOnly}
                                  value={filtroTexto}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setFiltroTexto(val);
                                    if (val.trim() !== "") {
                                      setMostrarTabla(true);
                                    }
                                  }}
                                  sx={{
                                    width: "14vw",
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell colSpan={2}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  size="medium"
                                  onClick={handleLimpiarFiltros}
                                  sx={{
                                    backgroundColor: "#18234f",
                                    color: "white",
                                    marginLeft: "5vw"
                                  }}
                                >
                                  Mostrar todos
                                </Button>
                              </Box>
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Typography
                                  variant="h9"
                                  gutterBottom
                                  sx={{
                                    fontWeight: "bold",
                                    color: "black",
                                    padding: "0.5vw 1vw",
                                    borderRadius: "8px",
                                    display: "inline-block",

                                    textAlign: "center",
                                  }}
                                >
                                  Busqueda por fechas:
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Select
                                  input={<OutlinedInput />}
                                  disabled={viewOnly}
                                  value={filtroFecha}
                                  onChange={(e) => {
                                    setFiltroFecha(e.target.value);
                                    setMostrarTabla(true);
                                  }}
                                  sx={{

                                    width: "14vw",


                                    height: "5vh",
                                    minHeight: "0px !important",
                                    overflow: "hidden",


                                    "&.MuiInputBase-root": {
                                      minHeight: "0px !important",
                                    },

                                    "& .MuiSelect-select": {
                                      minHeight: "0px !important",
                                      padding: "0 0.5vw !important",
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "1vw",
                                      lineHeight: "1",
                                    },

                                    "& .MuiOutlinedInput-notchedOutline": {

                                      top: 0,
                                      "& legend": { display: "none" },
                                    },

                                    "& .MuiSvgIcon-root": {
                                      display: "inline-block !important",
                                      position: "absolute",
                                      right: "0.5vw",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "1.2vw !important",
                                      width: "1.2vw !important",
                                      height: "1.2vw !important",
                                      pointerEvents: "none",

                                    },
                                    minWidth: "0px !important",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  }}
                                  className="selectFechas"
                                >
                                  <MenuItem
                                    sx={{
                                      fontSize: "1vw",
                                      padding: "0.5vw",
                                    }}
                                    value="todos"
                                  >
                                    Todos
                                  </MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="3m">Últimos 3 meses</MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="6m">Últimos 6 meses</MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="1y">Último año</MenuItem>
                                </Select>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "100%", overflowX: "auto" }}
              className="paperEntregas"
            >
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={activeTabEntregas}
                  onChange={handleTabEntregasChange}
                  aria-label="tabs entregas"
                  textColor="primary"
                  indicatorColor="primary"
                >

                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>Por entregar</span>
                        {mostrarTabla && (
                          <Chip
                            label={filtrarSolicitudes(solicitudesAEntregar).length}
                            size="small"
                            sx={{
                              backgroundColor: "#b33939",
                              color: "white",
                              fontWeight: "bold",
                              height: "20px",
                              fontSize: "0.75rem",
                              cursor: "pointer",
                              "& .MuiChip-label": {
                                padding: "0 6px"
                              }
                            }}
                          />
                        )}
                      </Box>
                    }
                    id="tab-0"
                    aria-controls="tabpanel-0"
                    sx={{
                      color: "black",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      marginRight: "8px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#d9eaf7",
                        color: "#006787",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#014e65",
                        color: "white",
                      },
                    }}
                  />
                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>Entregados</span>
                        {(mostrarTabla && filtroTexto.trim()) ? (
                          <Chip
                            label={filtrarSolicitudes(solicitudesEntregadas).length}
                            size="small"
                            sx={{
                              backgroundColor: "#b33939",
                              color: "white",
                              fontWeight: "bold",
                              height: "20px",
                              fontSize: "0.75rem",
                              cursor: "pointer",
                              "& .MuiChip-label": {
                                padding: "0 6px"
                              }
                            }}
                          />
                        ) : null}
                      </Box>
                    }
                    id="tab-1"
                    aria-controls="tabpanel-1"
                    sx={{
                      color: "black",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      marginRight: "8px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#d9eaf7",
                        color: "#006787",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#014e65",
                        color: "white",
                      },
                    }}
                  />
                </Tabs>
              </Box>
              {mostrarTabla ? (
                <>
                  <TabPanel value={activeTabEntregas} index={0}>
                    {renderTablaSolicitudes(filtrarSolicitudes(solicitudesAEntregar), false)}
                  </TabPanel>
                  <TabPanel value={activeTabEntregas} index={1}>
                    {filtroTexto.trim() ? (
                      renderTablaSolicitudes(filtrarSolicitudes(solicitudesEntregadas), true)
                    ) : (
                      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 4, backgroundColor: "#fff" }}>
                        <Typography sx={{ color: "#666", fontWeight: "bold" }}>
                          Realice una búsqueda por código de solicitud o nombre de paciente para mostrar las entregadas.
                        </Typography>
                      </Box>
                    )}
                  </TabPanel>
                </>
              ) : (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 6, backgroundColor: "#fff", borderRadius: 4 }}>
                  <Typography sx={{ color: "#666", fontWeight: "bold" }}>
                    Realice una búsqueda o presione "Mostrar todos" para ver los resultados.
                  </Typography>
                </Box>
              )}
            </Paper>
          </Stack>
        </Box>
      </Content>
    </Layout>
  );
};
export default Entregas;
